import { useEffect, useState } from 'react';
import axios from 'axios';
import { FaUserFriends } from "react-icons/fa";
import API_URL from '../config';
import {
  FaBriefcase,
  FaPlusCircle,
  FaChartBar,
  FaSignOutAlt,
  FaHospital,
  FaBars,
  FaTimes,
  FaUsers,
  FaCreditCard,
  FaUserTie,
  FaSearch,
  FaFileAlt,
  FaBookmark,
  FaUser, 
  FaLock,
  FaEnvelope,
  FaPhoneAlt,
  FaGraduationCap,
  FaMapMarkerAlt,
  FaBrain,
  FaMoneyBillWave,
  FaCheckCircle,
  FaPhone,
  FaCheck,
  FaTrashAlt,
  FaUnlockAlt
} from 'react-icons/fa';

function InstitutionDashboard() {

  const user = JSON.parse(localStorage.getItem('user'));

  if (!user) {
    window.location.href = '/';
  }
/*const [experience, setExperience] = useState('');
const [qualification, setQualification] = useState('');
const [locationFilter, setLocationFilter] = useState('');*/
const [analytics, setAnalytics] = useState({
  totalJobs: 0,
  totalApplicants: 0,
  totalCandidates: 0,
  shortlisted: 0,
  rejected: 0
});
const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const [savedCandidates, setSavedCandidates] = useState([]);

const [teamMembers, setTeamMembers] = useState([]);
const [teamLoading, setTeamLoading] = useState(false);
const [showAddRecruiterModal, setShowAddRecruiterModal] = useState(false);
const [teamSubmitting, setTeamSubmitting] = useState(false);
const [selectedJob, setSelectedJob] = useState(null);
const [showJobDetails, setShowJobDetails] = useState(false);

const [teamForm, setTeamForm] = useState({
  name: '',
  email: '',
  phone: '',
  password: ''
});

const [candidateKeyword, setCandidateKeyword] = useState('');
const [candidateResults, setCandidateResults] = useState([]);
const [jobs, setJobs] = useState([]);
const [plans, setPlans] = useState([]);
const [subscription, setSubscription] = useState(null);
const [subscriptionLoading, setSubscriptionLoading] = useState(false);
const [activeTab, setActiveTab] = useState('overview');
const [profileTab, setProfileTab] = useState('myProfile');

const [currentPassword, setCurrentPassword] = useState('');
const [newPassword, setNewPassword] = useState('');
const [confirmPassword, setConfirmPassword] = useState('');

const [changePasswordLoading, setChangePasswordLoading] = useState(false);
const [changePasswordMessage, setChangePasswordMessage] = useState('');
const [changePasswordMessageType, setChangePasswordMessageType] = useState('');
const [selectedPlan, setSelectedPlan] = useState(null);
const [showUpgradeModal, setShowUpgradeModal] = useState(false);
const [paymentLoading, setPaymentLoading] = useState(false);
const [form, setForm] = useState({
  profession: '',
  role: '',
  job_type: '',
  description: '',
  skills_required: '',
  experience_required: '',
  salary: '',
  location: '',
  tags: []
});
  

const [tagInput, setTagInput] = useState('');

useEffect(() => {
  fetchJobs();
  fetchApplications();
  fetchAnalytics();
  fetchRecruiterProfile();
  fetchSavedCandidates();
  fetchSubscriptionData();
  fetchTeamMembers();

}, []);
const fetchAnalytics = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/analytics/${user.id}`
    );

    setAnalytics(res.data);

  } catch (err) {

    console.log(err);
  }

};
  const updateStatus = async (
  applicationId,
  status
) => {

  try {

    await axios.put(
      `${API_URL}/applications/status/${applicationId}`,
      { status }
    );

    fetchApplications();

  } catch (err) {

    console.log(err);
  }
};
const [applications, setApplications] = useState([]);
const [recruiterProfile, setRecruiterProfile] = useState({
  recruiter_name: "",
  company_name: "",
  phone: "",
  email: "",
  website: "",
  address: "",
  about: "",
  company_logo: ""
});
const [companyLogoFile, setCompanyLogoFile] =
useState(null);
const fetchApplications = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/applications/recruiter/${user.id}`
    );

    setApplications(res.data);

  } catch (err) {

    console.log(err);
  }
};
const fetchSavedCandidates = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/saved-candidates/${user.id}`
    );

    setSavedCandidates(res.data);

  } catch (err) {

    console.log(err);

  }

};
const fetchTeamMembers = async () => {

  try {

    setTeamLoading(true);

    const res = await axios.get(
      `${API_URL}/team/${user.id}`
    );

    if (res.data.success) {

      setTeamMembers(
        Array.isArray(res.data.team)
          ? res.data.team
          : []
      );

    }

  } catch (err) {

    console.error(
      "FETCH TEAM ERROR:",
      err.response?.data || err
    );

    alert(
      err.response?.data?.message ||
      "Unable to load team members."
    );

  } finally {

    setTeamLoading(false);

  }

};
const handleAddRecruiter = async () => {

  try {

    if (
      !teamForm.name.trim() ||
      !teamForm.email.trim() ||
      !teamForm.phone.trim() ||
      !teamForm.password.trim()
    ) {

      alert("Please fill all recruiter details.");
      return;

    }

    setTeamSubmitting(true);

    const response = await axios.post(
      `${API_URL}/team/add`,
      {
        ownerId: user.id,
        name: teamForm.name.trim(),
        email: teamForm.email.trim(),
        phone: teamForm.phone.trim(),
        password: teamForm.password
      }
    );

    if (response.data.success) {

      alert("Recruiter added successfully.");

      setTeamForm({
        name: '',
        email: '',
        phone: '',
        password: ''
      });

      setShowAddRecruiterModal(false);

      await fetchTeamMembers();

    }

  } catch (err) {

    console.error(
      "ADD RECRUITER ERROR:",
      err.response?.data || err
    );

    if (err.response?.data?.limitReached) {

      alert(
        err.response.data.message ||
        "Recruiter user limit reached. Please upgrade your plan."
      );

    } else {

      alert(
        err.response?.data?.message ||
        "Unable to add recruiter."
      );

    }

  } finally {

    setTeamSubmitting(false);

  }

};
const handleRemoveRecruiter = async (memberId) => {

  const confirmed = window.confirm(
    "Are you sure you want to remove this recruiter from your team?"
  );

  if (!confirmed) {
    return;
  }

  try {

    await axios.post(
      `${API_URL}/team/remove`,
      {
        ownerId: user.id,
        memberId
      }
    );

    alert("Recruiter removed successfully.");

    fetchTeamMembers();

  } catch (err) {

    console.error(
      "REMOVE RECRUITER ERROR:",
      err.response?.data || err
    );

    alert(
      err.response?.data?.message ||
      "Unable to remove recruiter."
    );

  }

};
const fetchRecruiterProfile = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/recruiter-profile/${user.id}`
    );

    setRecruiterProfile({
      recruiter_name: res.data.recruiter_name || "",
      company_name: res.data.company_name || "",
      phone: res.data.phone || "",
      email: res.data.email || "",
      website: res.data.website || "",
      address: res.data.address || "",
      about: res.data.about || "",
      company_logo: res.data.company_logo || ""
    });

  } catch (err) {

    console.log(err);

  }

};


  const fetchJobs = async () => {

    try {

      const res = await axios.get(
        `${API_URL}/jobs/institution/${user.id}`
      );

      setJobs(res.data);

    } catch (err) {

      console.log(err);
    }
  };

const handleDeleteJob = async (job) => {
  const confirmed = window.confirm(
    `Are you sure you want to delete "${job.role}"? This action cannot be undone. The job will still count toward your posting limit.`
  );

  if (!confirmed) return;

  try {
    const res = await axios.delete(
      `${API_URL}/jobs/${job.id}`,
      {
        data: {
          institution_id: user.id,
        },
      }
    );

    if (res.data.success) {
      alert("Job deleted successfully.");
      await fetchJobs();
    }
  } catch (err) {
    console.error("DELETE JOB ERROR:", err);

    alert(
      err.response?.data?.message ||
      "Unable to delete job. Please try again."
    );
  }
};


  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };
  const handleTagKeyDown = (e) => {

  if (e.key === 'Enter') {

    e.preventDefault();

    if (
      tagInput.trim() !== '' &&
      !form.tags.includes(tagInput)
    ) {

      setForm({
        ...form,
        tags: [...form.tags, tagInput]
      });

      setTagInput('');
    }
  }
};const removeSavedCandidate = async (id) => {

  try {

    await axios.delete(
      `${API_URL}/saved-candidates/${id}`
    );

    fetchSavedCandidates();

  } catch (err) {

    console.log(err);

  }

};

const handlePostJob = async () => {

  try {

    await axios.post(
      `${API_URL}/jobs/create`,
      {
        institution_id: user.id,
        ...form
      }
    );

    alert('Job posted successfully');

    setForm({
  profession: '',
  role: '',
  job_type: '',
  description: '',
  skills_required: '',
  experience_required: '',
  salary: '',
  location: '',
  tags: []
});

    setTagInput('');

    fetchJobs();

    setActiveTab('jobs');

  } catch (err) {

    console.error("POST JOB ERROR:", err);

    // =====================================
    // SUBSCRIPTION LIMIT REACHED
    // =====================================

    if (err.response?.status === 403) {

      const data = err.response.data;

      const planName =
        data.plan || "your current plan";

      const limit =
        data.jobLimit;

      const used =
        data.usedJobs;

      if (
        limit !== undefined &&
        used !== undefined
      ) {

        alert(
          `🔒 Job Posting Limit Reached\n\n` +
          `Your ${planName} plan allows ${limit} active jobs.\n\n` +
          `Currently used: ${used}/${limit}\n\n` +
          `Please upgrade your plan to post more jobs.`
        );

      } else {

        alert(
          data.message ||
          "Your subscription does not allow you to post another job."
        );

      }

      return;
    }


    // =====================================
    // OTHER BACKEND ERRORS
    // =====================================

    alert(
      err.response?.data?.message ||
      "Error posting job. Please try again."
    );

  }

};

const saveRecruiterProfile = async () => {

  try {

    if (companyLogoFile) {

      const formData = new FormData();

      formData.append("logo", companyLogoFile);

      const uploadRes = await axios.post(
        `${API_URL}/recruiter-profile/upload-logo/${user.id}`,
        formData
      );

      setRecruiterProfile(prev => ({
        ...prev,
        company_logo: uploadRes.data.company_logo
      }));

    }

    await axios.post(
      `${API_URL}/recruiter-profile/save`,
      {
        user_id: user.id,
        ...recruiterProfile
      }
    );

    alert("Recruiter Profile Saved Successfully");

    fetchRecruiterProfile();

  } catch (err) {

    console.log(err);

    alert("Error saving profile");

  }

};
const handleChangePassword = async () => {
  setChangePasswordMessage('');

  if (!currentPassword || !newPassword || !confirmPassword) {
    setChangePasswordMessage('Please fill all password fields.');
    setChangePasswordMessageType('error');
    return;
  }

  if (newPassword !== confirmPassword) {
    setChangePasswordMessage('New password and confirm password do not match.');
    setChangePasswordMessageType('error');
    return;
  }

  if (newPassword.length < 8) {
    setChangePasswordMessage('New password must be at least 8 characters.');
    setChangePasswordMessageType('error');
    return;
  }

  try {
    setChangePasswordLoading(true);

    const response = await axios.post(
      '${API_URL}/auth/change-password',
      {
        userId: user.id,
        currentPassword,
        newPassword,
        confirmPassword
      }
    );

    if (response.data.success) {
      setChangePasswordMessage(
        response.data.message ||
        'Password changed successfully. Please login again with your new password.'
      );

      setChangePasswordMessageType('success');

      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  } catch (err) {
    setChangePasswordMessage(
      err.response?.data?.message ||
      'Unable to change password. Please try again.'
    );

    setChangePasswordMessageType('error');
  } finally {
    setChangePasswordLoading(false);
  }
};
  const handleLogout = () => {

    localStorage.removeItem('user');

    window.location.href = '/';
  };
  // ✅ Search candidates New 
 /*const searchCandidates = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/candidates/search`,
      {
        params: {
          keyword: candidateKeyword,
          experience,
          qualification,
          location: locationFilter
        }
      }
    );

    setCandidateResults(res.data);

  } catch (err) {

    console.log(err);

  }*/

const searchCandidates = async () => {
  try {
    const res = await axios.get(
      `${API_URL}/candidates/search`,
      {
        params: {
          keyword: candidateKeyword.trim(),
          recruiter_id: user.id
        }
      }
    );

    console.log('CANDIDATE SEARCH RESULT:', res.data);

    setCandidateResults(
      Array.isArray(res.data) ? res.data : []
    );

  } catch (err) {
    console.error(
      'CANDIDATE SEARCH ERROR:',
      err.response?.data || err
    );

    setCandidateResults([]);

    alert(
      err.response?.data?.message ||
      'Unable to search candidates.'
    );
  }
};


const unlockCandidate = async (candidateId) => {
  try {
    const response = await axios.post(
      `${API_URL}/candidates/unlock`,
      {
        recruiter_id: user.id,
        candidate_id: candidateId
      }
    );

    if (response.data?.success) {
      alert(
        response.data.alreadyUnlocked
          ? 'Candidate already unlocked.'
          : 'Candidate profile unlocked successfully.'
      );

      // Refresh both sections so the unlocked details
      // become visible everywhere.
      await Promise.all([
        searchCandidates(),
        fetchApplications()
      ]);
    }

  } catch (err) {
    const data = err.response?.data;

    if (data?.limitReached) {
      alert(
        data.message ||
        'Your candidate unlock limit has been reached. Please upgrade your plan.'
      );

      // Keep this if "subscription" is your existing tab ID.
      setActiveTab('subscription');
      return;
    }

    alert(
      data?.message || 'Unable to unlock candidate.'
    );
  }
};

const saveCandidate = async (candidateId) => {

  try {

    await axios.post(
      `${API_URL}/saved-candidates/save`,
      {
        recruiter_id: user.id,
        candidate_id: candidateId
      }
    );

    alert("Candidate Saved Successfully");

  } catch (err) {

    console.log(err);

    if (err.response?.data?.message) {

      alert(err.response.data.message);

    } else {

      alert("Error saving candidate");

    }

  }

};
const fetchSubscriptionData = async () => {
    try {
        setSubscriptionLoading(true);

        const recruiterId = user?.id;

        if (!recruiterId) return;

        const [plansResponse, subscriptionResponse] =
            await Promise.all([
                axios.get(
                    `${API_URL}/subscriptions/plans`
                ),
                axios.get(
                    `${API_URL}/subscriptions/recruiter/${recruiterId}`
                )
            ]);

        console.log(
            "SUBSCRIPTION PLANS:",
            plansResponse.data
        );

        console.log(
            "RECRUITER SUBSCRIPTION:",
            subscriptionResponse.data
        );

        if (plansResponse.data.success) {
            setPlans(
                plansResponse.data.plans || []
            );
        }

        if (subscriptionResponse.data.success) {
            setSubscription(
                subscriptionResponse.data.subscription || null
            );
        }

    } catch (error) {

        console.error(
            'FETCH SUBSCRIPTION DATA ERROR:',
            error
        );

    } finally {
        setSubscriptionLoading(false);
    }
};
const handleCreatePaymentOrder = async () => {

    if (!selectedPlan) {
        return;
    }

    try {

        setPaymentLoading(true);

        const recruiterId = user?.id;

        if (!recruiterId) {

            alert('Recruiter information not found.');
            return;

        }


        // ==========================================
        // Create Razorpay Order
        // ==========================================

        const response = await axios.post(
            `${API_URL}/subscriptions/create-order`,
            {
                recruiter_id: recruiterId,
                plan_id: selectedPlan.id
            }
        );


        if (!response.data.success) {

            alert(
                response.data.message ||
                'Unable to create payment order.'
            );

            return;
        }


        const order = response.data.order;
        const recruiter = response.data.recruiter;
        const plan = response.data.plan;
        const razorpayKeyId = response.data.key_id;


        // ==========================================
        // Make sure Razorpay Checkout is available
        // ==========================================

        if (!window.Razorpay) {

            alert(
                'Payment system could not be loaded. Please refresh the page and try again.'
            );

            return;

        }


        // ==========================================
        // Razorpay Checkout Options
        // ==========================================
        if (!razorpayKeyId) {

    alert(
        'Razorpay Key ID was not received from the server.'
    );

    return;

}
        const options = {

            key: razorpayKeyId,

            amount: order.amount,

            currency: order.currency,

            name: 'HireCura',

            description:
                `${plan.plan_name} Subscription`,

            order_id: order.id,

            prefill: {

                name:
                    recruiter.name || '',

                email:
                    recruiter.email || ''

            },

            notes: {

                recruiter_id:
                    String(recruiterId),

                plan_id:
                    String(plan.id)

            },


            // ======================================
            // Payment Success
            // ======================================

          handler: async function (paymentResponse) {

    console.log(
        'RAZORPAY PAYMENT SUCCESS:',
        paymentResponse
    );

    try {

        setPaymentLoading(true);

        // ==========================================
        // Verify payment on backend
        // ==========================================

        const verifyResponse = await axios.post(
            `${API_URL}/subscriptions/verify-payment`,
            {
                razorpay_order_id:
                    paymentResponse.razorpay_order_id,

                razorpay_payment_id:
                    paymentResponse.razorpay_payment_id,

                razorpay_signature:
                    paymentResponse.razorpay_signature
            }
        );


        console.log(
            'PAYMENT VERIFICATION RESPONSE:',
            verifyResponse.data
        );


        if (!verifyResponse.data.success) {

            alert(
                verifyResponse.data.message ||
                'Payment verification failed.'
            );

            return;

        }


        // ==========================================
        // Payment + Subscription successful
        // ==========================================

        alert(
            'Payment successful! Your subscription has been activated.'
        );


        // Close modal

        setShowUpgradeModal(false);

        setSelectedPlan(null);


        // ==========================================
        // Refresh subscription information
        // ==========================================

        await fetchSubscriptionData();


    } catch (error) {

        console.error(
            'PAYMENT VERIFICATION ERROR:',
            error
        );

        alert(
            error.response?.data?.message ||
            'Payment was completed, but subscription verification failed. Please contact support.'
        );

    } finally {

        setPaymentLoading(false);

    }

},

            theme: {

                color: '#2563eb'

            }

        };


        const razorpay =
            new window.Razorpay(options);


        razorpay.on(
            'payment.failed',
            function (response) {

                console.error(
                    'RAZORPAY PAYMENT FAILED:',
                    response.error
                );

                alert(
                    response.error?.description ||
                    'Payment failed. Please try again.'
                );

            }
        );


        razorpay.open();


    } catch (error) {

        console.error(
            'CREATE PAYMENT ORDER ERROR:',
            error
        );

        alert(
            error.response?.data?.message ||
            'Unable to start payment.'
        );

    } finally {

        setPaymentLoading(false);

    }

};

  return (

    <div className="min-h-screen lg:h-screen lg:overflow-hidden bg-gray-100 flex">
      <style>{`
        .no-visible-scrollbar { scrollbar-width: none; -ms-overflow-style: none; }
        .no-visible-scrollbar::-webkit-scrollbar { display: none; width: 0; height: 0; }
        @media (max-width: 1023px) {
          .no-visible-scrollbar { scrollbar-width: thin; -ms-overflow-style: auto; }
          .no-visible-scrollbar::-webkit-scrollbar { display: block; width: 6px; height: 6px; }
        }
      `}</style>
      

      {/* SIDEBAR */}
      <div className="hidden lg:block lg:sticky lg:top-0 lg:h-screen lg:overflow-y-auto no-visible-scrollbar lg:shrink-0 w-72 bg-gradient-to-b from-teal-700 to-emerald-800 text-white p-6">

        {/* BRAND */}
        <div className="mb-10">

          <div className="flex items-center gap-3">

            <div className="w-16 h-16 rounded-2xl overflow-hidden bg-white">

  <img
    src={
      (recruiterProfile.company_logo || user.company_logo)
        ? `${API_URL.replace('/api', '')}/${recruiterProfile.company_logo || user.company_logo}`
        : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'Recruiter')}`
    }
    alt="Company Logo"
    className="w-full h-full object-cover"
  />

</div>

            <div>
              <h2 className="text-xl   font-bold">
                {user.name}
              </h2>

              <p className="text-teal-100 text-sm  ">
                Healthcare Recruiter
              </p>
            </div>

          </div>

        </div>

        {/* MENU */}
        <div className="space-y-3">

          <button
            onClick={() => setActiveTab('overview')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'overview'
                ? ' bg-white text-teal-700'
                : ' hover:bg-white/10'
            }`}
          >
            <FaChartBar />
            Overview
          </button>

          <button
            onClick={() => setActiveTab('post')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'post'
                ? ' bg-white text-teal-700'
                : ' hover:bg-white/10'
            }`}
          >
            <FaPlusCircle />
            Post Job
          </button>

          <button
            onClick={() => setActiveTab('jobs')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'jobs'
                ? ' bg-white text-teal-700'
                : ' hover:bg-white/10'
            }`}
          >
            <FaBriefcase />
            My Jobs
          </button>

          <button
            onClick={() => setActiveTab('applications')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'applications'
                ? ' bg-white text-teal-700'
                : ' hover:bg-white/10'
            }`}
          >
            <FaFileAlt />
            Applications
          </button>
          <button
  onClick={() => setActiveTab('candidateSearch')}
  
  
  className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
    activeTab === 'candidateSearch'
      ? ' bg-white text-teal-700'
      : ' hover:bg-white/10'
  }`}
>
  <FaSearch />
  Candidate Search
</button>
<button
  onClick={() => setActiveTab('savedCandidates')}
  className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
    activeTab === 'savedCandidates'
      ? ' bg-white text-teal-700'
      : ' hover:bg-white/10'
  }`}
>
<FaBookmark />
Saved Candidates
</button>
<button
  onClick={() => setActiveTab("recruiterProfile")}
  className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
    activeTab === "recruiterProfile"
      ? "bg-white text-teal-700"
      : "hover:bg-white/10"
  }`}
>
  <FaUserTie />
  Recruiter Profile
</button>
<button
  onClick={() => setActiveTab('team')}
  className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
    activeTab === 'team'
      ? ' bg-white text-teal-700'
      : ' hover:bg-white/10'
  }`}
>
  <FaUserFriends />
  Team Management
</button>
<button
    onClick={() => setActiveTab('subscription')}
    className={`w-full flex items-center gap-3 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-left transition ${
        activeTab === 'subscription'
            ? "bg-white text-teal-700"
      : "hover:bg-white/10"
    }`}
>
    <FaCreditCard size={20} />
    <span>Subscription & Plans</span>
</button>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 p-4 rounded-2xl hover:bg-red-500 mt-10 transition"
          >
            <FaSignOutAlt />
            Logout
          </button>

        </div>

      </div>
      {/* MOBILE HEADER */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-white/95 backdrop-blur border-b border-slate-200 z-50 flex items-center justify-between px-4 py-3 shadow-sm">
        <button
          type="button"
          aria-label="Open navigation menu"
          onClick={() => setMobileMenuOpen(true)}
          className="w-11 h-11 inline-flex items-center justify-center rounded-xl bg-teal-50 text-teal-700 text-base sm:text-xl hover:bg-teal-100 transition"
        >
          <FaBars />
        </button>

        <div className="flex min-w-0 flex-col items-center">
          <h2 className="whitespace-nowrap text-lg font-extrabold leading-none tracking-tight">
            <span className="text-slate-900">Hire</span><span className="text-teal-600">Cura</span>
          </h2>
          <span className="mt-1 whitespace-nowrap text-[10px] font-medium tracking-[0.16em] text-slate-500">
            Where Careers Meet Care.
          </span>
          <span className="mt-1 text-[9px] font-semibold uppercase tracking-[0.18em] text-teal-700">
            Recruiter Portal
          </span>
        </div>

        <div className="h-11 w-11 shrink-0 overflow-hidden rounded-xl border border-teal-100 bg-white">
          <img
            src={(recruiterProfile.company_logo || user.company_logo) ? `${API_URL.replace('/api', '')}/${recruiterProfile.company_logo || user.company_logo}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'Recruiter')}&background=ffffff&color=0f766e&bold=true`}
            alt="Profile"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'Recruiter')}&background=ffffff&color=0f766e&bold=true`;
            }}
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      {mobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-slate-950/35 z-[60]"
          onClick={() => setMobileMenuOpen(false)}
        >
          <aside
            className="w-[min(18rem,82vw)] bg-gradient-to-b from-teal-700 to-emerald-800 text-white h-full shadow-2xl px-4 py-4 overflow-y-auto no-visible-scrollbar animate-in slide-in-from-left duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center gap-2 mb-5 pb-4 border-b border-white/15">
              <div className="flex items-center gap-2 min-w-0">
                <div className="w-10 h-10 rounded-xl bg-white/90 overflow-hidden border border-white/30 shrink-0">
                  <img
                    src={(recruiterProfile.company_logo || user.company_logo) ? `${API_URL.replace('/api', '')}/${recruiterProfile.company_logo || user.company_logo}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'Recruiter')}`}
                    alt="Company Logo"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <h2 className="font-bold text-base text-white truncate">{user.name || 'Recruiter'}</h2>
                  <p className="text-xs text-teal-100">Healthcare Recruiter</p>
                </div>
              </div>
              <button
                type="button"
                aria-label="Close navigation menu"
                onClick={() => setMobileMenuOpen(false)}
                className="w-8 h-8 shrink-0 inline-flex items-center justify-center rounded-lg text-white/90 hover:bg-white/10 text-lg transition"
              >
                <FaTimes />
              </button>
            </div>

            <p className="px-2 mb-2 text-[11px] font-bold tracking-[0.14em] uppercase text-teal-100/80">Workspace</p>
            <nav className="space-y-1">
              {[
                { id: 'overview', label: 'Overview', icon: <FaChartBar /> },
                { id: 'post', label: 'Post Job', icon: <FaPlusCircle /> },
                { id: 'jobs', label: 'My Jobs', icon: <FaBriefcase /> },
                { id: 'applications', label: 'Applications', icon: <FaFileAlt /> },
                { id: 'candidateSearch', label: 'Candidate Search', icon: <FaSearch /> },
                { id: 'savedCandidates', label: 'Saved Candidates', icon: <FaBookmark /> },
                { id: 'recruiterProfile', label: 'Recruiter Profile', icon: <FaUserTie /> },
                { id: 'team', label: 'Team Management', icon: <FaUserFriends /> },
                { id: 'subscription', label: 'Subscription & Plans', icon: <FaCreditCard /> }
              ].map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => {
                    setActiveTab(item.id);
                    setMobileMenuOpen(false);
                  }}
                  className={`w-full min-h-10 flex items-center gap-2 px-3 py-2 rounded-xl text-left font-medium transition duration-200 ${
                    activeTab === item.id
                      ? 'bg-white text-teal-800 shadow-sm'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  <span className={`w-7 h-7 shrink-0 flex items-center justify-center text-base ${
                    activeTab === item.id ? 'text-teal-700' : 'text-white'
                  }`}>{item.icon}</span>
                  <span className="flex-1 text-sm">{item.label}</span>
                  {activeTab === item.id && <span className="w-2 h-2 rounded-full bg-teal-600" />}
                </button>
              ))}
            </nav>

            <div className="mt-5 pt-4 border-t border-white/15">
              <button
                type="button"
                onClick={handleLogout}
                className="w-full min-h-12 flex items-center gap-3 px-4 py-3 rounded-2xl text-white hover:bg-red-500/90 transition font-medium"
              >
                <FaSignOutAlt className="text-lg" />
                <span className="text-base">Logout</span>
              </button>
            </div>
          </aside>
        </div>
      )}

      {/* MAIN CONTENT */}
     
<div className="flex-1 min-w-0 w-full overflow-x-hidden bg-slate-100 px-3 py-4 sm:px-5 lg:p-8 pt-20 sm:pt-24 lg:pt-8 lg:h-screen lg:overflow-y-auto no-visible-scrollbar">

  {/* OVERVIEW */}
  {activeTab === 'overview' && (
    <>
      {/* MOBILE OVERVIEW — mobile-only redesign */}
      <section className="lg:hidden max-w-7xl mx-auto space-y-5 pb-6">
        <div className="rounded-2xl bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-600 p-5 text-white shadow-md">
          <div className="flex items-start gap-3">
            <div className="w-12 h-12 shrink-0 rounded-xl bg-white/20 flex items-center justify-center">
              <FaChartBar className="text-2xl" />
            </div>
            <div className="min-w-0">
              <h1 className="text-xl font-extrabold tracking-tight">Dashboard Overview</h1>
              <p className="text-sm leading-5 text-teal-50 mt-1">
                Here's an overview of your recruitment activity.
              </p>
            </div>
          </div>
          <div className="mt-4 flex items-center justify-between rounded-xl bg-white/15 px-4 py-3">
            <span className="text-sm text-white/90">Your job listings</span>
            <span className="rounded-lg bg-white px-3 py-1.5 text-sm font-bold text-teal-800">
              {jobs.length} {jobs.length === 1 ? 'Job' : 'Jobs'}
            </span>
          </div>
        </div>

        {/* Mobile statistics */}
        <div className="grid grid-cols-2 gap-3">
          <div className="min-w-0 rounded-2xl border border-teal-100 bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-semibold leading-4 text-slate-500">Total Jobs</span>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-teal-50">
                <FaBriefcase className="text-lg text-teal-700" />
              </span>
            </div>
            <p className="mt-3 text-2xl font-extrabold tabular-nums text-slate-900">{analytics.totalJobs}</p>
            <p className="mt-1 text-xs text-slate-500">Jobs posted</p>
          </div>

          <div className="min-w-0 rounded-2xl border border-emerald-100 bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-semibold leading-4 text-slate-500">Applications</span>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-50">
                <FaUsers className="text-lg text-emerald-700" />
              </span>
            </div>
            <p className="mt-3 text-2xl font-extrabold tabular-nums text-slate-900">{analytics.totalApplicants}</p>
            <p className="mt-1 text-xs text-slate-500">Received</p>
          </div>

          <div className="col-span-2 min-w-0 rounded-2xl border border-blue-100 bg-white p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-50">
                <FaCheckCircle className="text-xl text-blue-700" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-slate-600">Active Jobs</p>
                <p className="mt-1 text-xs text-slate-500">Jobs currently in your listings</p>
              </div>
              <p className="text-2xl font-extrabold tabular-nums text-slate-900">{jobs.length}</p>
            </div>
          </div>
        </div>

        {/* Mobile recent job posts */}
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <div className="flex items-center justify-between gap-3 border-b border-slate-100 px-4 py-4">
            <div className="min-w-0">
              <h2 className="text-base font-bold text-slate-900">Recent Job Posts</h2>
              <p className="mt-1 text-xs leading-4 text-slate-500">A quick look at your latest job listings.</p>
            </div>
            <span className="shrink-0 rounded-lg bg-teal-50 px-3 py-2 text-xs font-bold text-teal-700">
              {jobs.length} {jobs.length === 1 ? 'job' : 'jobs'}
            </span>
          </div>

          <div className="space-y-3 p-3">
            {jobs.length === 0 ? (
              <div className="px-3 py-9 text-center">
                <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100">
                  <FaBriefcase className="text-2xl text-slate-400" />
                </div>
                <p className="text-sm font-bold text-slate-700">No jobs posted yet</p>
                <p className="mt-1 text-xs leading-5 text-slate-500">Your recent job listings will appear here.</p>
              </div>
            ) : (
              jobs.slice(0, 5).map((job) => (
                <div
                  key={job.id}
                  className="min-w-0 rounded-xl border border-slate-200 p-3 transition-colors hover:border-teal-200"
                >
                  <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-50">
                      <FaBriefcase className="text-lg text-teal-700" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h3 className="break-words text-sm font-bold capitalize leading-5 text-slate-900">
                        {job.role || 'Job Role'}
                      </h3>
                      <p className="mt-2 flex items-start gap-2 text-xs leading-5 text-slate-500">
                        <FaMapMarkerAlt className="mt-1 shrink-0 text-teal-600" />
                        <span className="break-words">{job.location || 'Location not specified'}</span>
                      </p>
                    </div>
                  </div>
                  <div className="mt-3 flex items-center justify-between gap-3 border-t border-slate-100 pt-3">
                    <span className="text-xs text-slate-500">Salary</span>
                    <span className="break-words text-sm font-bold text-teal-700">
                      {job.salary ? `₹${job.salary}` : 'Not specified'}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* DESKTOP OVERVIEW — original layout preserved */}
      <div className="hidden lg:block">
    <div className="max-w-7xl mx-auto">

      {/* Page Heading */}
      <div className="mb-8">
        <h1 className="text-2xl    font-bold text-slate-900">
          Dashboard Overview
        </h1>
        <p className="text-slate-500 mt-2">
          Here's an overview of your recruitment activity.
        </p>
      </div>

      {/* STATS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-5 mb-6 sm:mb-10">

        <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between">
            <h3 className="text-sm   font-medium text-slate-500">
              Total Jobs
            </h3>
            <div className="w-11 h-11 rounded-xl bg-teal-50 flex items-center justify-center">
              <FaBriefcase className="text-2xl text-teal-700" />
            </div>
          </div>

          <p className="text-3xl   font-bold text-slate-900 mt-5">
            {analytics.totalJobs}
          </p>
          <p className="text-sm   text-slate-500 mt-2">
            Jobs posted
          </p>
        </div>

        <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between">
            <h3 className="text-sm   font-medium text-slate-500">
              Total Applications
            </h3>
            <div className="w-11 h-11 rounded-xl bg-emerald-50 flex items-center justify-center">
              <FaUsers className="text-2xl text-emerald-700" />
            </div>
          </div>

          <p className="text-3xl   font-bold text-slate-900 mt-5">
            {analytics.totalApplicants}
          </p>
          <p className="text-sm   text-slate-500 mt-2">
            Applications received
          </p>
        </div>

        <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between">
            <h3 className="text-sm   font-medium text-slate-500">
              Active Jobs
            </h3>
            <div className="w-11 h-11 rounded-xl bg-blue-50 flex items-center justify-center">
              <FaCheckCircle className="text-2xl text-blue-700" />
            </div>
          </div>

          <p className="text-3xl   font-bold text-slate-900 mt-5">
            {jobs.length}
          </p>
          <p className="text-sm   text-slate-500 mt-2">
            Jobs in your listings
          </p>
        </div>

      </div>

      {/* RECENT JOBS */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden min-w-0">

        <div className="px-4 py-5 sm:px-6 md:px-8 border-b border-slate-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h2 className="text-lg    font-bold text-slate-900">
              Recent Job Posts
            </h2>
            <p className="text-sm   text-slate-500 mt-1">
              A quick look at your latest job listings.
            </p>
          </div>

          <span className="text-sm   font-medium text-teal-700 bg-teal-50 px-3 py-2 rounded-lg">
            {jobs.length} jobs
          </span>
        </div>

        <div className="p-3 sm:p-5 md:p-8">

          {jobs.length === 0 ? (

            <div className="py-12 text-center">
              <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
                <FaBriefcase className="text-3xl text-slate-400" />
              </div>
              <p className="font-semibold text-slate-700">
                No jobs posted yet
              </p>
              <p className="text-sm   text-slate-500 mt-2">
                Your recent job listings will appear here.
              </p>
            </div>

          ) : (

            <div className="space-y-4">

              {jobs.slice(0, 5).map((job) => (

                <div
                  key={job.id}
                  className="group border border-slate-200 rounded-2xl p-5 md:p-6 hover:border-teal-200 hover:bg-teal-50/30 transition-all duration-200"
                >

                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                    <div className="flex items-start gap-4 min-w-0">

                      <div className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center shrink-0">
                        <FaBriefcase className="text-xl text-teal-700" />
                      </div>

                      <div className="min-w-0">
                        <h3 className="font-bold text-base   text-slate-900 break-words capitalize">
                          {job.role}
                        </h3>

                        <p className="flex items-center gap-2 text-slate-500 mt-2">
                          <FaMapMarkerAlt className="text-teal-600 shrink-0" />
                          <span>{job.location}</span>
                        </p>
                      </div>

                    </div>

                    <div className="sm:text-right sm:pl-4">
                      <p className="text-[0.65rem] sm:text-sm lg:text-sm text-slate-500 mb-1">
                        Salary
                      </p>
                      <p className="text-base   font-bold text-teal-700">
                        ₹{job.salary}
                      </p>
                    </div>

                  </div>

                </div>

              ))}

            </div>

          )}

        </div>
      </div>

    </div>
      </div>
    </>
  )}


{activeTab === 'candidateSearch' && (
  <>
    {/* CANDIDATE SEARCH — MOBILE ONLY */}
    <div className="lg:hidden space-y-5 pb-6 min-w-0">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-teal-700 via-teal-600 to-emerald-600 p-5 text-white shadow-lg">
        <div className="absolute -right-5 -top-6 h-28 w-28 rounded-full bg-white/10" />
        <div className="absolute -right-1 bottom-0 h-16 w-16 rounded-full bg-white/10" />
        <div className="relative flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15 text-2xl">
            <FaSearch />
          </div>
          <div className="min-w-0 flex-1">
            <h1 className="text-xl font-extrabold tracking-tight">Candidate Search</h1>
            <p className="mt-1 text-sm text-teal-50">Find healthcare professionals for your team.</p>
          </div>
        </div>
        <div className="relative mt-4 rounded-xl border border-white/20 bg-white/10 px-4 py-3">
          <p className="text-xs font-medium text-teal-50">Candidates found</p>
          <p className="mt-0.5 text-2xl font-extrabold">{candidateResults.length}</p>
        </div>
      </div>

      {/* Mobile search controls */}
      <div className="rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
        <label className="mb-2 block text-sm font-semibold text-slate-700">Search candidates</label>
        <input
          type="text"
          placeholder="Name, mobile, skills, qualification..."
          value={candidateKeyword}
          onChange={(e) => setCandidateKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") searchCandidates();
          }}
          className="w-full min-w-0 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-base text-slate-800 placeholder:text-slate-400 outline-none transition focus:border-teal-500 focus:bg-white focus:ring-4 focus:ring-teal-500/10"
        />
        <button
          type="button"
          onClick={searchCandidates}
          className="mt-3 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl bg-teal-600 px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-teal-700"
        >
          <FaSearch /> Search Candidates
        </button>
      </div>

      {candidateResults.length === 0 ? (
        <div className="rounded-2xl border border-slate-200 bg-white px-5 py-8 text-center shadow-sm">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50 text-2xl text-teal-600">
            <FaUser />
          </div>
          <h3 className="mt-4 text-base font-bold text-slate-800">No candidates found</h3>
          <p className="mx-auto mt-2 max-w-xs text-sm leading-5 text-slate-500">Try another name, skill, qualification, or location.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {candidateResults.map((candidate) => (
            <div key={candidate.id} className="min-w-0 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex min-w-0 items-start gap-3">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-teal-100 bg-teal-50 text-xl text-teal-700">
                  <FaUser />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="break-words text-base font-extrabold uppercase leading-5 text-slate-900">{candidate.name || "Candidate"}</h3>
                  <p className="mt-1 text-sm text-slate-500">Healthcare Professional</p>
                </div>
              </div>

              <div className="mt-4 space-y-3 rounded-xl bg-slate-50 p-3">
                <div className="flex min-w-0 items-start gap-3">
                  <FaPhoneAlt className="mt-0.5 shrink-0 text-base text-teal-600" />
                  <span className="min-w-0 break-words text-sm text-slate-700">{candidate.is_unlocked ? (candidate.phone || "Not Available") : "XXXXXXXXXX"}</span>
                </div>
                <div className="flex min-w-0 items-start gap-3">
                  <FaEnvelope className="mt-0.5 shrink-0 text-base text-teal-600" />
                  <span className="min-w-0 break-all text-sm text-slate-700">{candidate.is_unlocked ? (candidate.email || "Not Available") : "XXXXXXXXXX"}</span>
                </div>
                <div className="flex min-w-0 items-start gap-3">
                  <FaGraduationCap className="mt-0.5 shrink-0 text-lg text-teal-600" />
                  <span className="min-w-0 break-words text-sm text-slate-700">{candidate.qualification || "Not specified"}</span>
                </div>
                <div className="flex min-w-0 items-start gap-3">
                  <FaBriefcase className="mt-0.5 shrink-0 text-base text-teal-600" />
                  <span className="min-w-0 break-words text-sm text-slate-700">{candidate.experience_years ?? "Not specified"} Years</span>
                </div>
                <div className="flex min-w-0 items-start gap-3">
                  <FaMapMarkerAlt className="mt-0.5 shrink-0 text-base text-teal-600" />
                  <span className="min-w-0 break-words text-sm capitalize text-slate-700">{candidate.location || "Not specified"}</span>
                </div>
                <div className="flex min-w-0 items-start gap-3">
                  <FaBrain className="mt-0.5 shrink-0 text-base text-teal-600" />
                  <span className="min-w-0 break-words text-sm text-slate-700">{candidate.skills || "Not specified"}</span>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-4 items-center gap-1.5 border-t border-slate-100 pt-3">
                <a
                  href={`/candidate/${candidate.id}`}
                  title="View Profile"
                  aria-label="View Profile"
                  className="inline-flex h-8 min-w-0 items-center justify-center rounded-lg bg-teal-600 text-sm text-white transition hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaUser />
                </a>
                {candidate.resume_url ? (
                  <a
                    href={`${API_URL.replace('/api', '')}/${candidate.resume_url}`}
                    target="_blank"
                    rel="noreferrer"
                    title="Resume"
                    aria-label="Resume"
                    className="inline-flex h-8 min-w-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-sm text-teal-700 transition hover:border-teal-300 hover:bg-teal-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                  >
                    <FaFileAlt />
                  </a>
                ) : (
                  <div title="No resume available" aria-label="No resume available" className="inline-flex h-8 min-w-0 items-center justify-center rounded-lg border border-slate-100 bg-slate-50 text-sm text-slate-300">
                    <FaFileAlt />
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => saveCandidate(candidate.id)}
                  title="Save Candidate"
                  aria-label="Save Candidate"
                  className="inline-flex h-8 min-w-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-sm text-teal-700 transition hover:border-teal-300 hover:bg-teal-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaBookmark />
                </button>
                {!candidate.is_unlocked ? (
                  <button
                    type="button"
                    onClick={() => unlockCandidate(candidate.id)}
                    title="Unlock Candidate"
                    aria-label="Unlock Candidate"
                    className="inline-flex h-8 min-w-0 items-center justify-center rounded-lg bg-slate-800 text-sm text-white transition hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2"
                  >
                    <FaUnlockAlt />
                  </button>
                ) : (
                  <div title="Candidate Unlocked" aria-label="Candidate Unlocked" className="inline-flex h-8 min-w-0 items-center justify-center rounded-lg border border-emerald-200 bg-emerald-50 text-sm text-emerald-700">
                    <FaLock />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* DESKTOP CANDIDATE SEARCH — ORIGINAL DESIGN */}
    <div className="hidden lg:block">
      
  <div className="space-y-6">

    {/* Page Header */}
    <div>
      <h1 className="text-2xl    font-bold text-slate-900">
        Candidate Search
      </h1>
      <p className="text-base   text-slate-500 mt-2">
        Find and connect with qualified healthcare professionals.
      </p>
    </div>

    {/* Search Bar */}
    <div className="flex flex-col sm:flex-row gap-3">
      <input
        type="text"
        placeholder="Search name, mobile, skills, qualification, location..."
        value={candidateKeyword}
        onChange={(e) => setCandidateKeyword(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") searchCandidates();
        }}
        className="flex-1 min-w-0 bg-white border border-slate-200
                   rounded-xl px-5 py-3.5 text-lg text-slate-800
                   placeholder:text-slate-400 outline-none
                   focus:border-teal-500 focus:ring-4
                   focus:ring-teal-500/10 transition"
      />

      <button
        type="button"
        onClick={searchCandidates}
        className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-3 sm:px-7 py-2 sm:py-3.5 rounded-xl font-semibold text-sm sm:text-base shadow-sm hover:shadow-md transition-all duration-200"
      >
        <FaSearch />
        Search
      </button>
    </div>

    {/* Results Count */}
    <div className="flex items-center justify-between">
      <h2 className="text-base   font-bold text-slate-800">
        Found {candidateResults.length} Candidates
      </h2>
    </div>

    {/* Candidate Results */}
    {candidateResults.length === 0 ? (
      <div className="bg-white border border-slate-200 rounded-2xl
                      p-10 text-center shadow-sm">
        <FaUser className="text-5xl text-slate-300 mx-auto" />
        <h3 className="text-lg   font-bold text-slate-800 mt-4">
          No candidates found
        </h3>
        <p className="text-base   text-slate-500 mt-2">
          Try another name, skill, qualification, or location.
        </p>
      </div>
    ) : (
      <div className="space-y-4 sm:space-y-5">
        {candidateResults.map((candidate) => (
          <div
            key={candidate.id}
            className="bg-white border border-slate-200 rounded-2xl
                       p-3    shadow-sm
                       hover:shadow-md hover:border-teal-200
                       transition-all duration-200"
          >

            {/* Candidate Name */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 shrink-0 rounded-xl
                              bg-teal-50 border border-teal-100
                              flex items-center justify-center">
                <FaUser className="text-2xl text-teal-700" />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-lg    font-bold
                               text-slate-900 uppercase break-words">
                  {candidate.name || "Candidate"}
                </h3>
                <p className="text-base   text-slate-600 mt-1">
                  Healthcare Professional
                </p>
              </div>
            </div>

            {/* Candidate Information */}
            <div className="grid grid-cols-1 sm:grid-cols-2
                            lg:grid-cols-3 gap-x-6 gap-y-5 mt-6">

              {/* Phone */}
              <div className="flex items-center gap-2 min-w-0">
                <FaPhoneAlt className="text-teal-600 text-xl shrink-0" />
                <span className="text-base   text-slate-700 break-words">
                  {candidate.is_unlocked
                    ? (candidate.phone || "Not Available")
                    : "XXXXXXXXXX"}
                </span>
              </div>

              {/* Email */}
              <div className="flex items-center gap-2 min-w-0">
                <FaEnvelope className="text-teal-600 text-xl shrink-0" />
                <span className="text-base   text-slate-700 break-all">
                  {candidate.is_unlocked
                    ? (candidate.email || "Not Available")
                    : "XXXXXXXXXX"}
                </span>
              </div>

              {/* Qualification */}
              <div className="flex items-center gap-2 min-w-0">
                <FaGraduationCap className="text-teal-600 text-2xl shrink-0" />
                <span className="text-base   capitalizetext-slate-700 break-words">
                  {candidate.qualification || "Not specified"}
                </span>
              </div>

              {/* Experience */}
              <div className="flex items-center gap-2 min-w-0">
                <FaBriefcase className="text-teal-600 text-xl shrink-0" />
                <span className="text-base   text-slate-700">
                  {candidate.experience_years ?? "Not specified"} Years
                </span>
              </div>

              {/* Location */}
              <div className="flex items-center gap-2 min-w-0">
                <FaMapMarkerAlt className="text-teal-600 text-xl shrink-0" />
                <span className="text-base   capitalize text-slate-700 break-words">
                  {candidate.location || "Not specified"}
                </span>
              </div>

              {/* Skills */}
              <div className="flex items-center gap-2 min-w-0">
                <FaBrain className="text-teal-600 text-xl shrink-0" />
                <span className="text-base   capitalize text-slate-700 break-words">
                  {candidate.skills || "Not specified"}
                </span>
              </div>

            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap items-center gap-3
                            mt-6 pt-5 border-t border-slate-100">

              {/* View Profile */}
              <a
                href={`/candidate/${candidate.id}`}
                className="inline-flex items-center justify-center gap-2 min-h-10 sm:min-h-12 px-3 sm:px-5 py-2 sm:py-3 rounded-xl bg-teal-600 hover:bg-teal-700 text-white font-semibold text-sm sm:text-base shadow-sm hover:shadow-md transition-all duration-200"
              >
                <FaUser />
                View Profile
              </a>

              {/* Resume */}
              {candidate.resume_url && (
                <a
                  href={`${API_URL.replace('/api', '')}/${candidate.resume_url}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-2 min-h-10 sm:min-h-12 px-3 sm:px-5 py-2 sm:py-3 rounded-xl bg-white text-slate-700 border border-slate-200 hover:bg-teal-50 hover:border-teal-400 hover:text-teal-700 font-semibold text-sm sm:text-base transition-all duration-200"
                >
                  <FaFileAlt className="text-teal-700" />
                  Resume
                </a>
              )}

              {/* Save Candidate */}
              <button
                type="button"
                onClick={() => saveCandidate(candidate.id)}
                className="inline-flex items-center justify-center gap-2 min-h-10 sm:min-h-12 px-3 sm:px-5 py-2 sm:py-3 rounded-xl bg-white text-slate-700 border border-slate-200 hover:bg-teal-50 hover:border-teal-400 hover:text-teal-700 font-semibold text-sm sm:text-base transition-all duration-200"
              >
                <FaBookmark className="text-teal-700" />
                Save
              </button>

              {/* Unlock Profile */}
                            
              {!candidate.is_unlocked ? (
                <button
                  type="button"
                  onClick={() => unlockCandidate(candidate.id)}
                  className="inline-flex items-center justify-center gap-2 min-h-10 sm:min-h-12 px-3 sm:px-5 py-2 sm:py-3 rounded-xl bg-slate-800 hover:bg-slate-900 text-white font-semibold text-sm sm:text-base shadow-sm hover:shadow-md transition-all duration-200"
                >
                  <FaUnlockAlt />
                  Unlock Profile
                </button>
              ) : (
                <div
                  className="inline-flex items-center justify-center gap-2
                            min-h-12 px-5 py-3 rounded-xl
                            bg-emerald-50 border border-emerald-200
                            text-emerald-700 font-semibold text-lg"
                >
                  <FaLock />
                  Unlock profile
                </div>
              )}


            </div>
          </div>
        ))}
      </div>
    )}
  </div>

    </div>
  </>
)}

        {/* POST JOB — MOBILE ONLY */}
{activeTab === 'post' && (
  <>
    <div className="lg:hidden space-y-5 pb-6">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-teal-700 via-teal-600 to-emerald-600 p-5 text-white shadow-lg">
        <div className="absolute -right-5 -top-6 h-28 w-28 rounded-full bg-white/10" />
        <div className="relative flex items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 text-xl">
            <FaPlusCircle />
          </div>
          <div className="min-w-0">
            <h1 className="text-xl font-extrabold leading-tight">Create New Job Post</h1>
            <p className="mt-1.5 text-sm leading-relaxed text-teal-50">Reach healthcare professionals across India.</p>
          </div>
        </div>
        <div className="relative mt-4 flex items-center gap-2 rounded-xl border border-white/20 bg-white/10 px-3 py-2.5 text-sm">
          <FaHospital className="shrink-0" />
          <span>Build your next healthcare team</span>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="mb-4 flex items-center gap-3 border-b border-slate-100 pb-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700"><FaFileAlt className="text-lg" /></div>
          <div>
            <h2 className="text-base font-bold text-slate-900">Basic Information</h2>
            <p className="mt-0.5 text-xs text-slate-500">Add the role and required skills.</p>
          </div>
        </div>
        <div className="space-y-3.5">
          <label className="block">
            <span className="mb-1.5 block text-sm font-semibold text-slate-700">Profession</span>
            <select name="profession" value={form.profession} onChange={handleChange} className="w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-800 outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100">
              <option value="">Select Profession</option>
              <option value="Doctor">Doctor</option><option value="Nursing">Nursing</option><option value="Pharmacy">Pharmacy</option><option value="Laboratory">Laboratory</option><option value="Radiology">Radiology</option><option value="Physiotherapy">Physiotherapy</option><option value="Medical College Faculty">Medical College Faculty</option><option value="Nursing & Healthcare Faculty">Nursing &amp; Healthcare Faculty</option><option value="Hospital Administration">Hospital Administration</option><option value="Pharmaceutical & Research">Pharmaceutical &amp; Research</option><option value="Allied Health">Allied Health</option><option value="Other Healthcare">Other Healthcare</option>
            </select>
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-semibold text-slate-700">Job Title</span>
            <input type="text" name="role" placeholder="Example: Staff Nurse" value={form.role} onChange={handleChange} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-100" />
          </label>
          <label className="block">
  <span className="mb-1.5 block text-sm font-semibold text-slate-700">
    Employment Type
  </span>

  <select
    name="job_type"
    value={form.job_type}
    onChange={handleChange}
    required
    className="w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-800 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100"
  >
    <option value="">Select Employment Type</option>
    <option value="Full Time">Full Time</option>
    <option value="Part Time">Part Time</option>
    <option value="Contract">Contract</option>
    <option value="Remote">Remote</option>
    <option value="Internship">Internship</option>
    <option value="Temporary">Temporary</option>
  </select>
</label>

          <label className="block">
            <span className="mb-1.5 block text-sm font-semibold text-slate-700">Skills Required</span>
            <textarea name="skills_required" placeholder="ICU, OT, Patient Care" value={form.skills_required} onChange={handleChange} rows={3} className="w-full min-w-0 resize-y rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-100" />
          </label>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="mb-4 flex items-center gap-3 border-b border-slate-100 pb-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700"><FaBriefcase className="text-lg" /></div>
          <div><h2 className="text-base font-bold text-slate-900">Job Details</h2><p className="mt-0.5 text-xs text-slate-500">Set the work terms and location.</p></div>
        </div>
        <div className="space-y-3.5">
          <label className="block"><span className="mb-1.5 block text-sm font-semibold text-slate-700">Experience Required</span><input type="text" name="experience_required" placeholder="e.g. 2–5 years" value={form.experience_required} onChange={handleChange} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></label>
          <label className="block"><span className="mb-1.5 block text-sm font-semibold text-slate-700">Salary (₹)</span><input type="text" name="salary" placeholder="e.g. 30,000 per month" value={form.salary} onChange={handleChange} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></label>
          <label className="block"><span className="mb-1.5 block text-sm font-semibold text-slate-700">Location</span><input type="text" name="location" placeholder="City, State" value={form.location} onChange={handleChange} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></label>
          <label className="block"><span className="mb-1.5 block text-sm font-semibold text-slate-700">Employment Type</span><select className="w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-800 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100"><option>Employment Type</option><option>Full Time</option><option>Part Time</option><option>Remote</option><option>Internship</option></select></label>
        </div>
        <div className="mt-4">
  <label
    htmlFor="description"
    className="mb-2 block text-sm font-semibold text-slate-700"
  >
    Job Description <span className="text-red-500">*</span>
  </label>

  <textarea
    id="description"
    name="description"
    value={form.description}
    onChange={handleChange}
    required
    minLength={20}
    maxLength={10000}
    rows={6}
    placeholder="Describe the job responsibilities, duties, requirements, working conditions, and other important details..."
    className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:ring-2 focus:ring-teal-100"
  />

  <p className="mt-1 text-xs text-slate-500">
    Minimum 20 characters. Be specific so candidates understand the role.
  </p>
</div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sky-50 text-sky-700"><FaBookmark className="text-lg" /></div>
          <div><h2 className="text-base font-bold text-slate-900">Tags / Specializations</h2><p className="mt-0.5 text-xs text-slate-500">Press Enter after each tag.</p></div>
        </div>
        <input type="text" placeholder="Type a tag and press Enter" value={tagInput} onChange={(e) => setTagInput(e.target.value)} onKeyDown={handleTagKeyDown} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-100" />
        <div className="mt-3 flex flex-wrap gap-2">{form.tags.map((tag, index) => <span key={index} className="rounded-full border border-teal-100 bg-teal-50 px-3 py-1.5 text-xs font-semibold text-teal-700">{tag}</span>)}</div>
      </div>
      
      <div className="overflow-hidden rounded-2xl border border-teal-100 bg-gradient-to-br from-teal-50 to-white shadow-sm">
        <div className="flex items-center justify-between border-b border-teal-100 px-4 py-3"><div className="flex items-center gap-2 text-sm font-bold text-slate-800"><FaChartBar /> Live Preview</div><span className="rounded-full bg-orange-100 px-2.5 py-1 text-[10px] font-bold tracking-wide text-orange-700">LIVE</span></div>
        <div className="p-4">
          <div className="flex items-start gap-3"><div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-100 text-xl font-extrabold text-teal-700">{user.name?.charAt(0)}</div><div className="min-w-0 flex-1"><h3 className="break-words text-base font-bold text-slate-900">{form.role || 'Job Title Preview'}</h3><p className="mt-1 truncate text-sm text-slate-500">{user.name}</p><p className="mt-2 text-xs text-slate-500">{form.profession || 'Healthcare profession'}</p></div></div>
          <label className="block">
  <span className="mb-1.5 block text-sm font-semibold text-slate-700">
    Job Type
  </span>

 <select
  name="job_type"
  value={form.job_type}
  onChange={handleChange}
  required
  className="w-full border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
>
  <option value="">Select Employment Type</option>
  <option value="Full Time">Full Time</option>
  <option value="Part Time">Part Time</option>
  <option value="Contract">Contract</option>
  <option value="Remote">Remote</option>
  <option value="Internship">Internship</option>
  <option value="Temporary">Temporary</option>
</select>
</label>
          <div className="mt-4 grid grid-cols-1 gap-2.5">
            <div className="flex min-w-0 items-center gap-2.5 rounded-xl bg-white/80 p-3"><FaMapMarkerAlt className="shrink-0 text-teal-600" /><div className="min-w-0"><p className="text-[11px] text-slate-500">Location</p><p className="break-words text-sm font-semibold text-slate-800">{form.location || 'Location not added'}</p></div></div>
            <div className="flex min-w-0 items-center gap-2.5 rounded-xl bg-white/80 p-3"><FaMoneyBillWave className="shrink-0 text-teal-600" /><div className="min-w-0"><p className="text-[11px] text-slate-500">Salary</p><p className="break-words text-sm font-semibold text-emerald-700">{form.salary ? `₹${form.salary}` : 'Salary not added'}</p></div></div>
            <div className="flex min-w-0 items-center gap-2.5 rounded-xl bg-white/80 p-3"><FaBriefcase className="shrink-0 text-teal-600" /><div className="min-w-0"><p className="text-[11px] text-slate-500">Experience</p><p className="break-words text-sm font-semibold text-slate-800">{form.experience_required || 'Not specified'}{form.experience_required ? ' years' : ''}</p></div></div>
          </div>
          {(form.skills_required || '').split(',').filter(skill => skill.trim() !== '').length > 0 && <div className="mt-4"><p className="mb-2 text-xs font-semibold text-slate-600">Skills Required</p><div className="flex flex-wrap gap-1.5">{(form.skills_required || '').split(',').filter(skill => skill.trim() !== '').map((skill, index) => <span key={index} className="max-w-full break-words rounded-full bg-teal-100 px-2.5 py-1 text-xs font-semibold text-teal-700">{skill.trim()}</span>)}</div></div>}
        </div>
      </div>

      <button onClick={handlePostJob} className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-teal-600 to-emerald-600 px-4 py-3.5 text-sm font-bold text-white shadow-md shadow-teal-600/20 transition active:scale-[0.99] hover:from-teal-700 hover:to-emerald-700"><FaPlusCircle /> Publish Job</button>
    </div>

    {/* DESKTOP POST JOB — original design preserved */}
    <div className="hidden lg:block">
      {activeTab === 'post' && (

  <div>

    <div className="mb-10">

      <h1 className="text-3xl   font-bold text-gray-800">
        Create New Job Post
      </h1>

      <p className="text-gray-500 mt-2 text-base  ">
        Reach thousands of healthcare professionals across India.
      </p>

    </div>

    <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">

      {/* LEFT SIDE FORM */}
      <div className="xl:col-span-2 bg-white rounded-3xl shadow p-4  ">

        {/* BASIC INFO */}
        <div>

          <h2 className="text-xl   font-bold mb-6 text-gray-800">
            Basic Information
          </h2>

          <div className="space-y-4 sm:space-y-5">
                          <select
                name="profession"
                value={form.profession}
                onChange={handleChange}
                className="w-full border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="">Select Profession</option>
                <option value="Doctor">Doctor</option>
                <option value="Nursing">Nursing</option>
                <option value="Pharmacy">Pharmacy</option>
                <option value="Laboratory">Laboratory</option>
                <option value="Radiology">Radiology</option>
                <option value="Physiotherapy">Physiotherapy</option>
                <option value="Medical College Faculty">Medical College Faculty</option>
                <option value="Nursing & Healthcare Faculty">
                  Nursing & Healthcare Faculty
                </option>
                <option value="Hospital Administration">
                  Hospital Administration
                </option>
                <option value="Pharmaceutical & Research">
                  Pharmaceutical & Research
                </option>
                <option value="Allied Health">Allied Health</option>
                <option value="Other Healthcare">Other Healthcare</option>
              </select>

            <input
              type="text"
              name="role"
              placeholder="Job Title (Example: Staff Nurse)"
              value={form.role}
              onChange={handleChange}
              className="w-full border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
            />

            <textarea
              name="skills_required"
              placeholder="Skills Required (ICU, OT, Patient Care)"
              value={form.skills_required}
              onChange={handleChange}
              rows="4"
              className="w-full border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
            />

          </div>

        </div>

        {/* JOB DETAILS */}
        <div className="mt-7 sm:mt-10">

          <h2 className="text-xl   font-bold mb-6 text-gray-800">
            Job Details
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

            <input
              type="text"
              name="experience_required"
              placeholder="Experience Required"
              value={form.experience_required}
              onChange={handleChange}
              className="border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
            />

            <input
              type="text"
              name="salary"
              placeholder="Salary (₹)"
              value={form.salary}
              onChange={handleChange}
              className="border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
            />

            <input
              type="text"
              name="location"
              placeholder="Location"
              value={form.location}
              onChange={handleChange}
              className="border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
            />

            <select
  name="job_type"
  value={form.job_type}
  onChange={handleChange}
  required
  className="border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
>
  <option value="">Select Employment Type</option>
  <option value="Full Time">Full Time</option>
  <option value="Part Time">Part Time</option>
  <option value="Contract">Contract</option>
  <option value="Remote">Remote</option>
  <option value="Internship">Internship</option>
  <option value="Temporary">Temporary</option>
</select>

          </div>

        </div>

        {/* TAGS */}
        {/* TAGS */}
<div className="mt-7 sm:mt-10">

  <h2 className="text-xl   font-bold mb-6 text-gray-800">
    Tags / Specializations
  </h2>

  <input
    type="text"
    placeholder="Type tag and press Enter"
    value={tagInput}
    onChange={(e) => setTagInput(e.target.value)}
    onKeyDown={handleTagKeyDown}
    className="w-full border p-4 rounded-2xl outline-none focus:ring-2 focus:ring-teal-500"
  />

  <div className="flex flex-wrap gap-3 mt-5">

    {form.tags.map((tag, index) => (

      <span
        key={index}
        className="bg-teal-100 text-teal-700 px-4 py-2 rounded-full font-semibold"
      >
        {tag}
      </span>

    ))}

  </div>

</div>
<div className="mt-4">
  <label
    htmlFor="description"
    className="mb-2 block text-sm font-semibold text-slate-700"
  >
    Job Description <span className="text-red-500">*</span>
  </label>

  <textarea
    id="description"
    name="description"
    value={form.description}
    onChange={handleChange}
    required
    minLength={20}
    maxLength={10000}
    rows={6}
    placeholder="Describe the job responsibilities, duties, requirements, working conditions, and other important details..."
    className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:ring-2 focus:ring-teal-100"
  />

  <p className="mt-1 text-xs text-slate-500">
    Minimum 20 characters. Be specific so candidates understand the role.
  </p>
</div>

        {/* SUBMIT */}
        <button
          onClick={handlePostJob}
          className="w-full mt-12 bg-gradient-to-r from-teal-600 to-emerald-700 text-white py-3 sm:py-5 rounded-2xl font-bold text-base sm:text-xl hover:opacity-90 transition"
        >
          Publish Job
        </button>

      </div>


      {/* RIGHT SIDE LIVE PREVIEW */}
      <div>

        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm p-4 sm:p-6 sticky top-6">

          <div className="flex justify-between items-start">

            <div className="flex gap-4">

              {/* LOGO */}
              <div className="w-16 h-16 rounded-2xl bg-teal-100 flex items-center justify-center text-3xl font-bold text-teal-700">

                {user.name?.charAt(0)}

              </div>

              <div>

                <h2 className="text-xl   font-bold text-gray-800">

                  {form.role || 'Job Title Preview'}

                </h2>

                <p className="text-gray-500 mt-1">

                  {user.name}

                </p>

              </div>

            </div>

            <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-sm   font-semibold">
              LIVE
            </span>

          </div>


          {/* DETAILS */}
          <div className="mt-8 space-y-5">

            <div>
              <p className="text-gray-500">
                Location
              </p>

              <h3 className="font-bold text-base   mt-1">
                {form.location || 'Location'}
              </h3>
            </div>

            <div>
              <p className="text-gray-500">
                Salary
              </p>

              <h3 className="font-bold text-base   mt-1 text-green-600">
                ₹{form.salary || '0'}
              </h3>
            </div>

            <div>
              <p className="text-gray-500">
                Experience
              </p>

              <h3 className="font-bold text-base   mt-1">
                {form.experience_required || '0'} yrs
              </h3>
            </div>

          </div>


          {/* SKILLS */}
          <div className="mt-8">

            <p className="text-gray-500 mb-3">
              Skills Required
            </p>

            <div className="flex flex-wrap gap-2">

              {(form.skills_required || '')
                .split(',')
                .filter(skill => skill.trim() !== '')
                .map((skill, index) => (

                  <span
                    key={index}
                    className="bg-teal-100 text-teal-700 px-3 py-2 rounded-full text-sm   font-semibold"
                  >
                    {skill}
                  </span>

                ))}

            </div>

          </div>


          {/* FOOTER */}
          <div className="mt-10 pt-6 border-t flex justify-between items-center">

            <div>

              <p className="text-sm   text-gray-400">
                Posted by
              </p>

              <h3 className="font-bold">
                {user.name}
              </h3>

            </div>

            <button className="bg-teal-600 text-white px-3 sm:px-5 py-1.5 sm:py-2 rounded-xl font-semibold">
              Apply
            </button>

          </div>

        </div>

      </div>

    </div>

  </div>

)}
    </div>
  </>
)}

        {/* MY JOBS — MOBILE ONLY */}
{activeTab === 'jobs' && (
  <div className="lg:hidden w-full min-w-0 space-y-4 pb-5">
    {/* Mobile page heading - consistent with the Overview and Post Job pages */}
    <div className="rounded-2xl bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-600 p-5 text-white shadow-md">
      <div className="flex items-start gap-3">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/20">
          <FaBriefcase className="text-2xl" />
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="text-xl font-extrabold tracking-tight">My Jobs</h1>
          <p className="mt-1 text-sm leading-5 text-teal-50">
            Manage your job postings and track their status.
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between rounded-xl bg-white/15 px-4 py-3">
        <span className="text-sm text-white/90">Your job listings</span>
        <span className="rounded-lg bg-white px-3 py-1.5 text-sm font-bold text-teal-800">
          {jobs.length} {jobs.length === 1 ? 'Job' : 'Jobs'}
        </span>
      </div>
    </div>

    {jobs.length === 0 ? (
      <div className="rounded-2xl border border-dashed border-teal-200 bg-white px-5 py-9 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50 text-2xl text-teal-600"><FaBriefcase /></div>
        <h2 className="mt-4 text-base font-bold text-slate-900">No jobs posted yet</h2>
        <p className="mx-auto mt-2 max-w-xs text-sm leading-5 text-slate-500">Your published jobs will appear here. Create your first job post to get started.</p>
        <button type="button" onClick={() => setActiveTab('post')} className="mt-5 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl bg-teal-600 px-4 py-3 text-sm font-bold text-white transition hover:bg-teal-700">
          <FaPlusCircle /> Post a Job
        </button>
      </div>
    ) : (
      <div className="space-y-4">
        {jobs.map((job) => {
          const isActive = String(job.status || '').toLowerCase() === 'active';
          return (
            <article key={job.id} className="w-full min-w-0 overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_3px_12px_rgba(15,23,42,0.06)]">
              <div className={`h-1 w-full ${isActive ? 'bg-gradient-to-r from-teal-500 to-emerald-400' : 'bg-slate-300'}`} />
              <div className="p-4">
                {/* Job title and status share a stable, aligned header */}
                <div className="flex min-w-0 items-start gap-3">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-teal-100 bg-teal-50 text-lg text-teal-700">
                    <FaBriefcase />
                  </div>
                  <div className="min-w-0 flex-1 pt-0.5">
                    <h2 className="break-words text-[15px] font-extrabold leading-5 text-slate-900">{job.role || 'Untitled Position'}</h2>
                    <p className="mt-1 break-words text-xs leading-4 text-slate-500">{job.profession || 'Healthcare role'}</p>
                  </div>
                  <span className={`inline-flex max-w-[92px] shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1.5 text-[11px] font-bold leading-none ${isActive ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
                    <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${isActive ? 'bg-emerald-500' : 'bg-slate-400'}`} />
                    <span className="truncate">{job.status || 'Unknown'}</span>
                  </span>
                </div>

                {/* Mobile job information: icon + value, one item per line */}
                <div className="mt-4 space-y-2.5">
                  <div className="flex min-w-0 items-center gap-3 rounded-xl bg-slate-50 px-3.5 py-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-base text-teal-600 shadow-sm"><FaMapMarkerAlt /></span>
                    <p className="min-w-0 break-words text-sm font-semibold leading-5 text-slate-800">{job.location || 'Not specified'}</p>
                  </div>
                  <div className="flex min-w-0 items-center gap-3 rounded-xl bg-slate-50 px-3.5 py-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-base text-teal-600 shadow-sm"><FaMoneyBillWave /></span>
                    <p className="min-w-0 break-words text-sm font-semibold leading-5 text-slate-800">{job.salary != null && job.salary !== '' ? `₹${job.salary}` : 'Not specified'}</p>
                  </div>
                  <div className="flex min-w-0 items-center gap-3 rounded-xl bg-slate-50 px-3.5 py-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-base text-teal-600 shadow-sm"><FaBriefcase /></span>
                    <p className="min-w-0 break-words text-sm font-semibold leading-5 text-slate-800">{job.experience_required != null && job.experience_required !== '' ? `${job.experience_required} years` : 'Not specified'}</p>
                  </div>
                </div>

                {/* Aligned action row */}
                <div className="mt-4 grid grid-cols-[minmax(0,1fr)_46px] items-stretch gap-2.5 border-t border-slate-100 pt-4">
                  <button type="button" onClick={() => { setSelectedJob(job); setShowJobDetails(true); }} className="flex min-h-12 min-w-0 items-center justify-center gap-2 rounded-xl bg-teal-600 px-3 py-3 text-sm font-bold text-white transition hover:bg-teal-700 active:bg-teal-800">
                    <FaFileAlt className="shrink-0" /> <span className="truncate">View Details</span>
                  </button>
                  <button type="button" onClick={() => handleDeleteJob(job)} aria-label={`Delete ${job.role || 'job'}`} title="Delete job" className="flex h-12 w-[46px] shrink-0 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-600 transition hover:bg-rose-100">
                    <FaTrashAlt />
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    )}
  </div>
)}

{/* Existing desktop My Jobs layout — unchanged */}
<div className="hidden lg:block">
{/* MY JOBS */}


{activeTab === 'jobs' && (
  <div className="space-y-6">

    {/* Page Header */}
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="text-2xl    font-bold text-slate-900">
          My Jobs
        </h1>
        <p className="text-base    text-slate-500 mt-2">
          Manage your job postings and track their status.
        </p>
      </div>

      <div className="inline-flex items-center gap-2 self-start sm:self-auto
                      bg-teal-50 border border-teal-100 rounded-xl px-4 py-3">
        <span className="w-2.5 h-2.5 rounded-full bg-teal-600" />
        <span className="text-base   font-semibold text-teal-800">
          {jobs.length} {jobs.length === 1 ? "Job Posting" : "Job Postings"}
        </span>
      </div>
    </div>

    {/* Empty State */}
    {jobs.length === 0 ? (
      <div className="bg-white rounded-2xl border border-slate-200
                      shadow-sm p-12 text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-teal-50
                        flex items-center justify-center">
          <FaBriefcase className="text-4xl text-teal-600" />
        </div>

        <h2 className="text-xl   font-bold text-slate-900 mt-5">
          No jobs posted yet
        </h2>

        <p className="text-base   text-slate-500 mt-2">
          Your published jobs will appear here.
        </p>
      </div>
    ) : (

      /* Job Cards */
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">

        {jobs.map((job) => (
          <div
            key={job.id}
            className="group bg-white rounded-2xl border border-slate-200
                       shadow-sm hover:shadow-lg hover:border-teal-200
                       hover:-translate-y-1 transition-all duration-300
                       overflow-hidden flex flex-col"
          >

            {/* Top Accent */}
            <div className="h-1.5 bg-gradient-to-r from-teal-500 to-emerald-500" />

            <div className="p-6 flex flex-col flex-1">

              {/* Job Header */}
              <div className="flex items-start gap-3">

                {/* Briefcase Icon */}
                <div className="w-12 h-12 shrink-0 rounded-xl
                                bg-teal-50 border border-teal-100
                                flex items-center justify-center">
                  <FaBriefcase className="text-3xl text-teal-700" />
                </div>

                {/* Job Role and Company */}
                <div className="flex-1 min-w-0 pt-0.5">
                  <h2 className="text-lg    font-bold
                                 text-slate-900 uppercase leading-tight
                                 break-words
                                 group-hover:text-teal-700 transition-colors">
                    {job.role || "Untitled Position"}
                  </h2>

                 
                </div>

                {/* Status: Top Right */}
                <span
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5
                              rounded-full text-sm   font-semibold shrink-0 ${
                    String(job.status || "").toLowerCase() === "active"
                      ? "bg-emerald-50 text-emerald-700"
                      : "bg-slate-100 text-slate-600"
                  }`}
                >
                  <span
                    className={`w-2 h-2 rounded-full ${
                      String(job.status || "").toLowerCase() === "active"
                        ? "bg-emerald-500"
                        : "bg-slate-400"
                    }`}
                  />
                  {job.status || "Unknown"}
                </span>

              </div>

              {/* Divider */}
              <div className="border-t border-slate-200 my-5" />

              {/* Job Details: Icons and Values Only */}
              <div className="space-y-5 flex-1">

                {/* Location */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaMapMarkerAlt className="text-2xl text-teal-600" />
                  </div>

                  <div className="min-w-0">
                    <p className="text-base    font-semibold
                                  text-slate-700 break-words">
                      {job.location || "Not specified"}
                    </p>
                  </div>
                </div>

                {/* Salary */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaMoneyBillWave className="text-2xl text-teal-600" />
                  </div>

                  <div className="min-w-0">
                    <p className="text-base    font-semibold
                                  text-slate-700">
                      {job.salary != null && job.salary !== ""
                        ? `Salary: ₹${job.salary}`
                        : "Not specified"}
                    </p>
                  </div>
                </div>

                {/* Experience */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaBriefcase className="text-2xl text-teal-600" />
                  </div>

                  <div className="min-w-0">
                    <p className="text-base    font-semibold
                                  text-slate-700">
                      {job.experience_required != null &&
                       job.experience_required !== ""
                        ? `Experience: ${job.experience_required} years`
                        : "Not specified"}
                    </p>
                  </div>
                </div>

              </div>

              {/* Bottom Action Buttons */}
              <div className="grid grid-cols-[1fr_auto] gap-3 mt-6 pt-5
                              border-t border-slate-100">

                {/* View Details */}
                <button
                  type="button"
                  onClick={() => {
                    setSelectedJob(job);
                    setShowJobDetails(true);
                  }}
                  className="flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white px-3 sm:px-4 py-2 sm:py-3.5 rounded-xl text-sm sm:text-base font-bold shadow-sm hover:shadow-md transition-all duration-200"
                >
                  View Details
                </button>

                {/* Dustbin / Delete */}
                <button
                  type="button"
                  onClick={() => handleDeleteJob(job)}
                  aria-label={`Delete ${job.role || "job"}`}
                  title="Delete job"
                  className="w-14 flex items-center justify-center bg-rose-50 hover:bg-rose-100 border border-rose-200 hover:border-rose-300 text-rose-600 rounded-xl transition-all duration-200"
                >
                  <FaTrashAlt className="text-xl" />
                </button>

              </div>

            </div>
          </div>
        ))}

      </div>
    )}
  </div>
)}

</div>

{showJobDetails && selectedJob && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div className="w-full max-w-2xl max-h-[85vh] overflow-y-auto rounded-3xl bg-white p-3   shadow-xl">
      <div className="flex items-center justify-between gap-4 mb-6">
        <h2 className="text-xl   font-bold text-teal-700">
          Job Details
        </h2>

        <button
          onClick={() => {
            setShowJobDetails(false);
            setSelectedJob(null);
          }}
          className="text-2xl text-gray-500 hover:text-gray-800"
          aria-label="Close job details"
        >
          &times;
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[
          ["Job Role", selectedJob.role],
          ["Profession", selectedJob.profession],
          ["Location", selectedJob.location],
          ["Salary", selectedJob.salary],
          ["Experience Required", selectedJob.experience_required],
          ["Required Skills", selectedJob.skills_required],
          ["Status", selectedJob.status],
          ["Expiry Date", selectedJob.expires_at],
        ].map(([label, value]) => (
          <div key={label} className="rounded-xl bg-gray-50 p-4">
            <p className="text-sm   text-gray-500">{label}</p>
            <p className="mt-1 font-semibold text-gray-800 break-words">
              {value || "Not provided"}
            </p>
          </div>
        ))}
      </div>

      <button
        onClick={() => {
          setShowJobDetails(false);
          setSelectedJob(null);
        }}
        className="mt-6 w-full rounded-xl bg-teal-600 px-3 sm:px-5 py-2 sm:py-3 font-semibold text-white hover:bg-teal-700"
      >
        Close
      </button>
    </div>
  </div>
)}

        {/* TEAM MANAGEMENT */}
               {/* TEAM MANAGEMENT */}
{activeTab === 'team' && (

  <div>

    {/* MOBILE TEAM MANAGEMENT */}
    <div className="lg:hidden space-y-4">
      <div className="rounded-3xl bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-500 p-5 text-white shadow-lg">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl border border-white/25 bg-white/15">
              <FaUsers className="text-xl" />
            </div>
            <h1 className="text-2xl font-extrabold leading-tight">Team Management</h1>
            <p className="mt-2 text-sm leading-5 text-teal-50">Manage recruiters in your organization.</p>
          </div>
          <div className="shrink-0 rounded-2xl border border-white/25 bg-white/15 px-3 py-3 text-center">
            <p className="text-2xl font-extrabold leading-none">{teamMembers.length}</p>
            <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide">Members</p>
          </div>
        </div>
        <button
          onClick={() => {
            setTeamForm({ name: '', email: '', phone: '', password: '' });
            setShowAddRecruiterModal(true);
          }}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-white px-4 py-3 text-sm font-bold text-teal-700 shadow-sm transition hover:bg-teal-50"
        >
          <FaPlusCircle /> Add Recruiter
        </button>
      </div>

      <div className="rounded-2xl border border-teal-100 bg-white p-4 shadow-sm">
        <div className="mb-3 flex items-center justify-between gap-3">
          <div>
            <p className="text-sm font-medium text-gray-500">Recruiter Users</p>
            <p className="mt-1 text-2xl font-extrabold text-gray-900">
              {teamMembers.length} / {subscription?.max_recruiter_users === -1 ? '∞' : subscription?.max_recruiter_users || 1}
            </p>
          </div>
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-xl text-teal-700">
            <FaUsers />
          </div>
        </div>
        {subscription?.max_recruiter_users !== -1 && (
          <>
            <div className="mb-2 flex items-center justify-between text-xs text-gray-500">
              <span>Team capacity</span>
              <span>{Math.min(Math.round((teamMembers.length / Number(subscription?.max_recruiter_users || 1)) * 100), 100)}%</span>
            </div>
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-gray-100">
              <div
                className={`h-full rounded-full transition-all ${teamMembers.length >= Number(subscription?.max_recruiter_users || 1) ? 'bg-red-500' : 'bg-teal-600'}`}
                style={{ width: `${Math.min((teamMembers.length / Number(subscription?.max_recruiter_users || 1)) * 100, 100)}%` }}
              />
            </div>
          </>
        )}
      </div>

      {teamLoading ? (
        <div className="rounded-2xl border border-gray-100 bg-white p-8 text-center shadow-sm">
          <p className="text-sm text-gray-500">Loading team members...</p>
        </div>
      ) : teamMembers.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-teal-200 bg-white px-5 py-8 text-center shadow-sm">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-50 text-xl text-teal-700"><FaUsers /></div>
          <h2 className="font-bold text-gray-800">No team members yet</h2>
          <p className="mt-1 text-sm text-gray-500">Add a recruiter to collaborate with your organization.</p>
          <button
            onClick={() => {
              setTeamForm({ name: '', email: '', phone: '', password: '' });
              setShowAddRecruiterModal(true);
            }}
            className="mt-4 rounded-xl bg-teal-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-teal-700"
          >Add Recruiter</button>
        </div>
      ) : (
        <div className="space-y-3">
          {teamMembers.map((member) => {
            const isOwner = Number(member.id) === Number(user.id);
            return (
              <div key={member.id} className="overflow-hidden rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-lg font-extrabold text-teal-700">
                    {(member.name || 'R').charAt(0).toUpperCase()}
                  </div>
                  <div className="min-w-0 flex-1">
                    <h2 className="break-words text-base font-bold leading-5 text-gray-900">{isOwner ? member.name || user.name : member.name}</h2>
                    <p className="mt-1 text-sm text-gray-500">{isOwner ? 'Owner / Admin' : 'Recruiter'}</p>
                  </div>
                  <span className={`shrink-0 rounded-full px-2.5 py-1 text-[10px] font-bold ${isOwner ? 'bg-teal-50 text-teal-700' : 'bg-emerald-50 text-emerald-700'}`}>
                    {isOwner ? 'OWNER' : 'ACTIVE'}
                  </span>
                </div>
                <div className="mt-4 space-y-3 rounded-xl bg-gray-50 p-3">
                  <div className="flex min-w-0 items-start gap-3 text-sm text-gray-600">
                    <FaEnvelope className="mt-0.5 shrink-0 text-teal-600" />
                    <span className="min-w-0 break-all">{member.email || 'Not available'}</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-gray-600">
                    <FaPhoneAlt className="shrink-0 text-teal-600" />
                    <span className="break-words">{member.phone || 'Not available'}</span>
                  </div>
                </div>
                {!isOwner && (
                  <button onClick={() => handleRemoveRecruiter(member.id)} className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-rose-200 bg-rose-50 px-4 py-2.5 text-sm font-semibold text-rose-600 transition hover:bg-rose-100">
                    <FaTrashAlt /> Remove Recruiter
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>

    {/* DESKTOP TEAM MANAGEMENT — original layout preserved */}
    <div className="hidden lg:block">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">

      <div>

        <h1 className="text-2xl   font-bold text-gray-800">
          Team Management
        </h1>

        <p className="text-gray-500 mt-2">
          Manage recruiters who belong to your organization.
        </p>

      </div>

      <button
        onClick={() => {

          setTeamForm({
            name: '',
            email: '',
            phone: '',
            password: ''
          });

          setShowAddRecruiterModal(true);

        }}
        className="bg-teal-600 hover:bg-teal-700 text-white px-3 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold transition"
      >
        + Add Recruiter
      </button>

    </div>


    {/* TEAM USAGE */}

    <div className="bg-white rounded-2xl shadow-sm border p-4 sm:p-5 mb-6">

      <div className="flex justify-between items-center mb-3">

        <div>

          <p className="text-sm   text-gray-500">
            Recruiter Users
          </p>

          <h2 className="text-xl   font-bold text-gray-900">
            {teamMembers.length} / {
              subscription?.max_recruiter_users === -1
                ? '∞'
                : subscription?.max_recruiter_users || 1
            }
          </h2>

        </div>

        <div className="w-12 h-12 rounded-xl bg-teal-50 text-teal-700 flex items-center justify-center text-2xl">
          <FaUsers />
        </div>

      </div>


      {subscription?.max_recruiter_users !== -1 && (

        <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">

          <div
            className={`h-full rounded-full transition-all ${
              teamMembers.length >=
              Number(subscription?.max_recruiter_users || 1)
                ? 'bg-red-500'
                : 'bg-teal-600'
            }`}
            style={{
              width: `${Math.min(
                (
                  teamMembers.length /
                  Number(subscription?.max_recruiter_users || 1)
                ) * 100,
                100
              )}%`
            }}
          />

        </div>

      )}

    </div>


    {/* TEAM MEMBERS */}

    {teamLoading ? (

      <div className="bg-white rounded-2xl shadow p-10 text-center">

        <p className="text-gray-500">
          Loading team members...
        </p>

      </div>

    ) : teamMembers.length === 0 ? (

      <div className="bg-white rounded-2xl shadow p-10 text-center">

        <p className="text-gray-500">
          No team members found.
        </p>

      </div>

    ) : (

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {teamMembers.map((member) => {

          const isOwner =
            Number(member.id) === Number(user.id);

          return (

            <div
              key={member.id}
              className="bg-white rounded-2xl shadow-sm border p-3  "
            >

              <div className="flex items-start justify-between gap-4">

                <div className="flex items-center gap-4">

                  <div className="w-14 h-14 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center text-2xl font-bold">

                    {(member.name || 'R').charAt(0).toUpperCase()}

                  </div>

                  <div>

                    <h2 className="text-lg   font-bold text-gray-900">
                      {isOwner
                        ? member.name || user.name
                        : member.name}
                    </h2>

                    <p className="text-sm   text-gray-500">
                      {isOwner
                        ? 'Owner / Admin'
                        : 'Recruiter'}
                    </p>

                  </div>

                </div>


                <span
                  className={`px-3 py-1 rounded-full text-[0.65rem] sm:text-sm lg:text-sm font-semibold ${
                    isOwner
                      ? 'bg-teal-100 text-teal-700'
                      : 'bg-green-100 text-green-700'
                  }`}
                >
                  {isOwner ? 'OWNER' : 'ACTIVE'}
                </span>

              </div>

                <div className="mt-5 flex flex-col gap-3 text-base">

                <p className="flex items-center gap-2 text-gray-600">
                  <FaEnvelope className="text-teal-600 shrink-0" />
                  <span>{member.email || 'Not available'}</span>
                </p>

                <p className="flex items-center gap-2 text-gray-600">
                  <FaPhoneAlt className="text-teal-600 shrink-0" />
                  <span>{member.phone || 'Not available'}</span>
                </p>

              </div>


              {!isOwner && (

                <button
                  onClick={() =>
                    handleRemoveRecruiter(member.id)
                  }
                  className="mt-5 bg-red-600 hover:bg-red-700 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl font-semibold"
                >
                  Remove
                </button>

              )}

            </div>

          );

        })}

      </div>

    )}


    </div>

    {/* ADD RECRUITER MODAL */}

    {showAddRecruiterModal && (

      <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4">

        <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl">

          <div className="p-6 border-b flex justify-between items-center">

            <div>

              <h2 className="text-lg   font-bold text-gray-900">
                Add Recruiter
              </h2>

              <p className="text-sm   text-gray-500 mt-1">
                Add a recruiter to your organization.
              </p>

            </div>

            <button
              onClick={() => setShowAddRecruiterModal(false)}
              className="text-gray-400 hover:text-gray-700 text-2xl"
            >
              ×
            </button>

          </div>


          <div className="p-6 space-y-4">

            <input
              type="text"
              placeholder="Full Name"
              value={teamForm.name}
              onChange={(e) =>
                setTeamForm({
                  ...teamForm,
                  name: e.target.value
                })
              }
              className="w-full border p-4 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none"
            />

            <input
              type="email"
              placeholder="Email Address"
              value={teamForm.email}
              onChange={(e) =>
                setTeamForm({
                  ...teamForm,
                  email: e.target.value
                })
              }
              className="w-full border p-4 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none"
            />

            <input
              type="text"
              placeholder="Mobile Number"
              value={teamForm.phone}
              onChange={(e) =>
                setTeamForm({
                  ...teamForm,
                  phone: e.target.value
                })
              }
              className="w-full border p-4 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none"
            />

            <input
              type="password"
              placeholder="Temporary Password"
              value={teamForm.password}
              onChange={(e) =>
                setTeamForm({
                  ...teamForm,
                  password: e.target.value
                })
              }
              className="w-full border p-4 rounded-xl focus:ring-2 focus:ring-teal-500 outline-none"
            />


            <div className="flex gap-3 pt-3">

              <button
                onClick={() => setShowAddRecruiterModal(false)}
                className="flex-1 border border-gray-300 text-gray-700 py-2 sm:py-3 rounded-xl font-semibold hover:bg-gray-50"
              >
                Cancel
              </button>

              <button
                onClick={handleAddRecruiter}
                disabled={teamSubmitting}
                className={`flex-1 py-2 sm:py-3 rounded-xl font-semibold text-white${
                  teamSubmitting
                    ? 'bg-teal-400 cursor-not-allowed'
                    : 'bg-teal-600 hover:bg-teal-700'
                }`}
              >
                {teamSubmitting
                  ? 'Adding...'
                  : 'Add Recruiter'}
              </button>

            </div>

          </div>

        </div>

      </div>

    )}

  </div>

)}
        {activeTab === 'subscription' && (
          <><>
            {showUpgradeModal && selectedPlan && (
              <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center overflow-y-auto bg-black/50 px-4 py-4">

                <div className="bg-white w-full max-w-md max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-2xl shadow-2xl">

                  {/* Header */}
                  <div className="p-6 border-b border-gray-100">

                    <div className="flex items-start justify-between">

                      <div>
                        <h3 className="text-lg   font-bold text-gray-900">
                          Upgrade Your Plan
                        </h3>

                        <p className="text-sm   text-gray-500 mt-1">
                          Review your selected plan before continuing.
                        </p>
                      </div>

                      <button
                        onClick={() => {
                          setShowUpgradeModal(false);
                          setSelectedPlan(null);
                        } }
                        className="text-gray-400 hover:text-gray-600 text-2xl"
                      >
                        ×
                      </button>

                    </div>

                  </div>


                  {/* Plan Details */}
                  <div className="p-6">

                    <div className="bg-teal-50 border border-teal-100 rounded-xl p-5">

                      <p className="text-sm   text-teal-600 font-medium">
                        Selected Plan
                      </p>

                      <h4 className="text-lg   font-bold text-gray-900 mt-1">
                        {selectedPlan.plan_name}
                      </h4>

                      <div className="mt-3">

                        <span className="text-2xl   font-extrabold text-gray-900">
                          ₹{Number(
                            selectedPlan.price
                          ).toLocaleString('en-IN')}
                        </span>

                        <span className="text-sm   text-gray-500 ml-1">
                          / {selectedPlan.billing_period === 'monthly'
                            ? 'month'
                            : selectedPlan.billing_period === 'yearly'
                              ? 'year'
                              : selectedPlan.billing_period}
                        </span>

                      </div>

                    </div>


                    {/* Important Information */}
                    <div className="mt-5 space-y-3">

                      <div className="flex justify-between text-base">
                        <span className="text-gray-600">
                          Job postings
                        </span>

                        <span className="font-semibold text-gray-900">
                          {selectedPlan.job_limit === -1
                            ? 'Unlimited'
                            : selectedPlan.job_limit}
                        </span>
                      </div>


                      <div className="flex justify-between text-base">
                        <span className="text-gray-600">
                          Saved candidates
                        </span>

                        <span className="font-semibold text-gray-900">
                          {selectedPlan.max_saved_candidates == null
                            ? 'Unlimited'
                            : selectedPlan.max_saved_candidates}
                        </span>
                      </div>


                      <div className="flex justify-between text-base">
                        <span className="text-gray-600">
                          AI Matching
                        </span>

                        <span className="font-semibold">
                          {selectedPlan.ai_match_enabled
                            ? 'Included'
                            : 'Not included'}
                        </span>
                      </div>

                    </div>


                    <div className="mt-5 bg-gray-50 rounded-lg p-4 text-base text-gray-600">
                      You will be redirected to secure payment to complete
                      your subscription upgrade.
                    </div>


                    {/* Buttons */}
                    <div className="flex gap-3 mt-6">

                      <button
                        onClick={() => {
                          setShowUpgradeModal(false);
                          setSelectedPlan(null);
                        } }
                        className="flex-1 py-3 rounded-xl border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50"
                      >
                        Cancel
                      </button>


                    <button
    onClick={handleCreatePaymentOrder}
    disabled={paymentLoading}
    className={`flex-1 py-3 rounded-xl font-semibold transition ${
    paymentLoading
        ? 'bg-teal-400 text-white cursor-not-allowed'
        : 'bg-teal-600 text-white hover:bg-teal-700'
}`}
>
    {paymentLoading
        ? 'Creating Order...'
        : 'Continue to Payment'}
</button>

                    </div>

                  </div>

                </div>

              </div>
            )}

          </><div className="space-y-5 lg:space-y-6">

              {/* MOBILE HEADER */}
              <div className="lg:hidden relative overflow-hidden rounded-3xl bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-500 p-5 text-white shadow-lg">
                <div className="relative z-10 flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25">
                      <FaCreditCard className="text-xl" />
                    </div>
                    <h1 className="text-2xl font-extrabold tracking-tight">Subscription & Plans</h1>
                    <p className="mt-1 max-w-xs text-sm leading-5 text-teal-50">Manage your plan, usage, and hiring features.</p>
                  </div>
                  <div className="shrink-0 rounded-2xl border border-white/25 bg-white/15 px-3 py-2 text-center">
                    <p className="text-2xl font-extrabold leading-none">{plans.length}</p>
                    <p className="mt-1 text-[11px] font-semibold text-teal-50">Plans</p>
                  </div>
                </div>
              </div>

              {/* DESKTOP HEADER */}
              <div className="hidden lg:block">
                <h2 className="text-xl   font-bold text-gray-900">
                  Subscription & Plans
                </h2>
                <p className="text-gray-500 mt-1">
                  Manage your recruiter subscription and job posting limits.
                </p>
              </div>


              {/* Loading */}
              {subscriptionLoading ? (

                <div className="bg-white rounded-xl border p-4   text-center">
                  <p className="text-gray-500">
                    Loading subscription details...
                  </p>
                </div>

              ) : (

                <>
                  {/* Current Subscription */}
                  {/* Current Subscription */}

                  <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

                    {/* Header */}
                    <div className="p-4 sm:p-5 lg:p-6 border-b border-gray-100">

                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 sm:gap-4">

                        <div>
                          <p className="text-sm   font-medium text-gray-500">
                            Current Subscription
                          </p>

                          <h3 className="text-xl   font-bold text-gray-900 mt-1">
                            {subscription?.plan_name || 'No Active Plan'}
                          </h3>

                          {subscription?.plan_code && (
                            <p className="text-sm   text-gray-500 mt-1">
                              {subscription.plan_code}
                            </p>
                          )}
                        </div>


                        <div>
                          <span
                            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm   font-semibold ${subscription?.status === 'active'
                                ? 'bg-green-100 text-green-700'
                                : 'bg-gray-100 text-gray-600'}`}
                          >
                            <span
                              className={`w-2 h-2 rounded-full ${subscription?.status === 'active'
                                  ? 'bg-green-500'
                                  : 'bg-gray-400'}`}
                            ></span>

                            {subscription?.status === 'active'
                              ? 'Active'
                              : 'No Active Subscription'}
                          </span>
                        </div>

                      </div>

                    </div>


                    {/* Subscription Details */}

                    {subscription ? (

                      <div className="p-4 sm:p-5 lg:p-6">

                        {/* Usage */}

                        <div className="mb-6">

                          <div className="flex items-center justify-between gap-3 mb-3">

                            <div>
                              <p className="text-sm sm:text-sm font-semibold text-gray-700 leading-5">
                                Job Posting Usage
                              </p>

                              <p className="text-xs sm:text-sm text-gray-500 mt-1 leading-5">
                                {subscription.active_jobs} of{' '}
                                {subscription.job_limit === -1
                                  ? 'Unlimited'
                                  : subscription.job_limit}{' '}
                                active jobs used
                              </p>
                            </div>


                            <div className="shrink-0 text-base sm:text-lg font-bold text-gray-900 tabular-nums">

                              {subscription.job_limit === -1
                                ? 'Unlimited'
                                : `${subscription.active_jobs}/${subscription.job_limit}`}

                            </div>

                          </div>


                          {/* Progress Bar */}

                          {subscription.job_limit !== -1 && (

                            <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">

                              <div
                                className={`h-full rounded-full transition-all ${Number(subscription.active_jobs) >=
                                    Number(subscription.job_limit)
                                    ? 'bg-red-500'
                                    : Number(subscription.active_jobs) >=
                                      Number(subscription.job_limit) * 0.8
                                      ? 'bg-yellow-500'
                                      : 'bg-teal-600'}`}
                                style={{
                                  width: `${Math.min(
                                    (
                                      Number(subscription.active_jobs) /
                                      Number(subscription.job_limit)
                                    ) * 100,
                                    100
                                  )}%`
                                }}
                              ></div>

                            </div>

                          )}

                        </div>


                        {/* Statistics */}

                        <div className="grid grid-cols-3 items-stretch gap-2 sm:gap-4">

                          {/* Active Jobs */}

                          <div className="min-w-0 min-h-[112px] bg-gray-50 rounded-xl p-2.5 sm:p-4 flex flex-col">

                            <p className="min-h-[36px] text-xs sm:text-sm text-gray-500 leading-4 sm:leading-5 break-words">
                              Active Jobs
                            </p>

                            <p className="mt-auto pt-2 text-lg sm:text-xl font-bold text-gray-900 break-words leading-6">
                              {jobs.length}
                            </p>

                          </div>


                          {/* Job Limit */}

                          <div className="min-w-0 min-h-[112px] bg-gray-50 rounded-xl p-2.5 sm:p-4 flex flex-col">

                            <p className="min-h-[36px] text-xs sm:text-sm text-gray-500 leading-4 sm:leading-5 break-words">
                              Job Limit
                            </p>

                            <p className="mt-auto pt-2 text-lg sm:text-xl font-bold text-gray-900 break-words leading-6">

                              {subscription.job_limit === -1
                                ? 'Unlimited'
                                : subscription.job_limit}

                            </p>

                          </div>


                          {/* Remaining */}

                          <div className="min-w-0 min-h-[112px] bg-gray-50 rounded-xl p-2.5 sm:p-4 flex flex-col">

                            <p className="min-h-[36px] text-xs sm:text-sm text-gray-500 leading-4 sm:leading-5 break-words">
                              Remaining Jobs
                            </p>

                            <p className="mt-auto pt-2 text-lg sm:text-xl font-bold text-gray-900 break-words leading-6">

                              {subscription.remaining_jobs}

                            </p>

                          </div>

                        </div>


                        {/* Dates */}

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-5 sm:mt-6 pt-5 sm:pt-6 border-t border-gray-100">

                          <div>

                            <p className="text-sm   text-gray-500">
                              Subscription Started
                            </p>

                            <p className="font-semibold text-gray-900 mt-1">

                              {subscription.started_at
                                ? new Date(
                                  subscription.started_at
                                ).toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })
                                : '-'}

                            </p>

                          </div>


                          <div>

                            <p className="text-sm   text-gray-500">
                              Subscription Expires
                            </p>

                            <p className="font-semibold text-gray-900 mt-1">

                              {subscription.expires_at
                                ? new Date(
                                  subscription.expires_at
                                ).toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })
                                : 'No expiry'}

                            </p>

                          </div>

                        </div>

                      </div>

                    ) : (

                      /* No Subscription */
                      <div className="p-8 text-center">

                        <div className="text-gray-400 text-5xl mb-3">
                          —
                        </div>

                        <h4 className="text-base   font-semibold text-gray-800">
                          No Active Subscription
                        </h4>

                        <p className="text-sm   text-gray-500 mt-1">
                          Choose a plan below to start posting jobs and accessing
                          recruiter features.
                        </p>

                      </div>

                    )}

                  </div>


                  {/* Available Plans */}

                  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-4 sm:mb-5">

                    <div>
                      <h3 className="text-lg   font-bold text-gray-900">
                        Choose Your Hiring Plan
                      </h3>

                      <p className="text-sm   text-gray-500 mt-1">
                        Select the plan that best fits your healthcare recruitment needs.
                      </p>
                    </div>

                    <div className="text-base text-gray-500">
                      All plans include secure recruiter access
                    </div>

                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">


                    {plans.map((plan) => {

                      const isCurrent = subscription?.plan_id === plan.id;

                      const isUnlimited = (value) => value === -1 || value === null;

                      const formatPeriod = (period) => {

                        if (period === 'monthly') {
                          return 'per month';
                        }

                        if (period === 'yearly') {
                          return 'per year';
                        }

                        if (period === '3_months') {
                          return '3 months';
                        }

                        return period;
                      };

                      const features = [
                        {
                          label: 'Active Job Postings',
                          value: isUnlimited(plan.job_limit)
                            ? 'Unlimited'
                            : plan.job_limit
                        },
                        {
                          label: 'Saved Candidates',
                          value: isUnlimited(plan.max_saved_candidates)
                            ? 'Unlimited'
                            : plan.max_saved_candidates
                        },
                        {
                          label: 'Recruiter Users',
                          value: isUnlimited(plan.max_recruiter_users)
                            ? 'Unlimited'
                            : plan.max_recruiter_users
                        },
                        {
                          label: 'AI Candidate Matching',
                          included: Boolean(plan.ai_match_enabled)
                        },
                        {
                          label: 'Advanced Candidate Search',
                          included: Boolean(plan.advanced_search_enabled)
                        },
                        {
                          label: 'Hiring Analytics',
                          included: Boolean(plan.analytics_enabled)
                        },
                        {
                          label: 'Featured Jobs',
                          value: plan.featured_jobs === -1
                            ? 'Unlimited'
                            : plan.featured_jobs > 0
                              ? plan.featured_jobs
                              : null
                        },
                        {
                          label: 'Company Branding',
                          included: Boolean(plan.company_branding)
                        },
                        {
                          label: 'Priority Support',
                          included: Boolean(plan.priority_support)
                        }
                      ];

                      return (
                        <div
                          key={plan.id}
                          className={`relative bg-white rounded-2xl border shadow-sm overflow-hidden transition-all duration-200 hover:shadow-lg ${isCurrent
                              ? 'border-teal-500 ring-2 ring-teal-100'
                              : 'border-gray-200'}`}
                        >

                          {/* Current Plan Badge */}
                          {isCurrent && (
                            <div className="absolute top-0 right-0">
                              <div className="bg-teal-600 text-white text-[10px] sm:text-sm font-bold px-2.5 sm:px-4 py-1.5 sm:py-2 rounded-bl-xl">
                                CURRENT PLAN
                              </div>
                            </div>
                          )}


                          {/* Plan Header */}
                          <div className="p-4 sm:p-5 lg:p-6 border-b border-gray-100">

                            <div className="pr-20 sm:pr-24">

                              <h4 className="text-lg   font-bold text-gray-900">
                                {plan.plan_name}
                              </h4>

                              <p className="text-sm   text-gray-500 mt-1">
                                {plan.plan_code === 'FOUNDING'
                                  ? 'Special founding hospital plan'
                                  : plan.plan_code === 'FREE'
                                    ? 'Get started with basic hiring'
                                    : plan.plan_code.includes('ENTERPRISE')
                                      ? 'For growing healthcare organizations'
                                      : 'For professional healthcare hiring'}
                              </p>

                            </div>


                            {/* Price */}
                            <div className="mt-5 flex items-end gap-1">

                              <span className="text-2xl   font-extrabold text-gray-900">
                                {Number(plan.price) === 0
                                  ? 'Free'
                                  : `₹${Number(plan.price).toLocaleString('en-IN')}`}
                              </span>

                              {Number(plan.price) > 0 && (
                                <span className="text-sm   text-gray-500 mb-1">
                                  {formatPeriod(plan.billing_period)}
                                </span>
                              )}

                            </div>

                          </div>


                          {/* Plan Features */}
                          <div className="p-4 sm:p-5 lg:p-6">

                            <p className="text-sm   font-semibold text-gray-900 mb-4">
                              What's included
                            </p>

                            <div className="space-y-3">

                              {features.map((feature, index) => {

                                const hasValue = feature.value !== null &&
                                  feature.value !== undefined;

                                const included = feature.included === true;

                                const shouldShow = hasValue || included;

                                if (!shouldShow) {
                                  return null;
                                }

                                return (
                                  <div
                                    key={index}
                                    className="flex items-start justify-between gap-3 text-base"
                                  >

                                    <div className="flex items-start gap-2">

                                      <span className="text-green-600 font-bold mt-0.5">
                                        ✓
                                      </span>

                                      <span className="text-gray-600">
                                        {feature.label}
                                      </span>

                                    </div>


                                    {hasValue && (
                                      <span className="font-semibold text-gray-900 whitespace-nowrap">
                                        {feature.value}
                                      </span>
                                    )}

                                  </div>
                                );

                              })}

                            </div>


                            {/* Button */}
                            <button
                              disabled={isCurrent}
                              onClick={() => {

                                if (!isCurrent && Number(plan.price) > 0) {

                                  setSelectedPlan(plan);
                                  setShowUpgradeModal(true);

                                }
                              } }
                              className={`w-full mt-5 sm:mt-6 py-2.5 sm:py-3 rounded-xl text-sm sm:text-base font-semibold transition ${isCurrent
                                  ? 'bg-teal-50 text-teal-600 cursor-default'
                                  : Number(plan.price) === 0
                                    ? 'bg-gray-100 text-gray-500 cursor-default'
                                    : 'bg-teal-600 text-white hover:bg-teal-700'}`}
                            >

                              {isCurrent
                                ? '✓ Current Plan'
                                : Number(plan.price) === 0
                                  ? 'Free Plan'
                                  : 'Upgrade'}

                            </button>

                          </div>

                        </div>
                      );
                    })}

                  </div>

                </>

              )}

            </div></>
)}

        {/* APPLICATIONS - MOBILE VIEW */}
        {activeTab === 'applications' && (
          <>
            <div className="lg:hidden w-full space-y-5 pb-4">
              {/* Matching mobile page header */}
              <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-500 p-5 text-white shadow-lg">
                <div className="relative z-10 flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/25">
                      <FaUsers className="text-xl" />
                    </div>
                    <h1 className="text-2xl font-extrabold tracking-tight">Applications</h1>
                    <p className="mt-1 max-w-xs text-sm leading-5 text-teal-50">Review candidates and manage their application status.</p>
                  </div>
                  <div className="shrink-0 rounded-2xl border border-white/25 bg-white/15 px-3 py-2 text-center">
                    <p className="text-2xl font-extrabold leading-none">{applications.length}</p>
                    <p className="mt-1 text-[11px] font-semibold text-teal-50">Applicants</p>
                  </div>
                </div>
              </div>

              {applications.length === 0 ? (
                <div className="rounded-2xl border border-slate-200 bg-white px-5 py-10 text-center shadow-sm">
                  <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50">
                    <FaUsers className="text-2xl text-teal-600" />
                  </div>
                  <h2 className="text-base font-bold text-slate-800">No applications yet</h2>
                  <p className="mt-2 text-sm leading-5 text-slate-500">Candidate applications will appear here.</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {applications.map((app) => (
                    <div key={app.id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
                      <div className="flex items-start gap-3">
                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-teal-50 text-lg font-extrabold text-teal-700 ring-1 ring-teal-100">
                          {app.name?.trim()?.charAt(0)?.toUpperCase() || 'C'}
                        </div>
                        <div className="min-w-0 flex-1">
                          <h2 className="break-words text-base font-extrabold uppercase leading-5 text-slate-900">{app.name}</h2>
                          <p className="mt-1 break-words text-sm font-semibold capitalize text-teal-700">{app.role}</p>
                        </div>
                        <span className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1.5 text-xs font-bold ${
                          app.status === 'Shortlisted' ? 'border-emerald-200 bg-emerald-50 text-emerald-700' : app.status === 'Rejected' ? 'border-red-200 bg-red-50 text-red-700' : 'border-amber-200 bg-amber-50 text-amber-700'
                        }`}>
                          <span className={`h-1.5 w-1.5 rounded-full ${app.status === 'Shortlisted' ? 'bg-emerald-500' : app.status === 'Rejected' ? 'bg-red-500' : 'bg-amber-500'}`} />
                          {app.status || 'Pending'}
                        </span>
                      </div>

                      <div className="mt-4 space-y-3 rounded-xl bg-slate-50 p-3.5">
                        <div className="flex min-w-0 items-start gap-3 text-sm">
                          <FaPhone className="mt-0.5 shrink-0 text-teal-600" />
                          <span className="min-w-0 break-all font-semibold text-slate-700">{app.is_unlocked ? (app.phone || 'Not Available') : 'XXXXXXXXXX'}</span>
                        </div>
                        <div className="flex min-w-0 items-start gap-3 text-sm">
                          <FaEnvelope className="mt-0.5 shrink-0 text-teal-600" />
                          <span className="min-w-0 break-all font-semibold text-slate-700">{app.is_unlocked ? (app.email || 'Not Available') : 'XXXXXXXXXX'}</span>
                        </div>
                        <div className={`flex items-center gap-3 text-sm font-semibold ${app.has_resume ? 'text-emerald-700' : 'text-rose-600'}`}>
                          <FaFileAlt className="shrink-0" />
                          <span>{app.has_resume ? 'Resume Available' : 'Resume Not Available'}</span>
                        </div>
                      </div>

                      <div className="mt-3 flex items-stretch gap-2">
                        {!app.is_unlocked && (
                          <button onClick={() => unlockCandidate(app.candidate_id)} 
                            className="inline-flex h-9 w-10 shrink-0 items-center justify-center self-center rounded-lg border border-teal-200 bg-teal-50 text-teal-700 transition hover:bg-teal-100"
                          >
                            <FaUnlockAlt className="mr-2 shrink-0" /> 
                          </button>
                        )}
                        {app.resume_url && (
                          <a
                            href={`${API_URL.replace('/api', '')}/${app.resume_url.replace('backend/', '')}`}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="View Resume"
                            title="View Resume"
                            className="inline-flex h-9 w-10 shrink-0 items-center justify-center self-center rounded-lg border border-teal-200 bg-teal-50 text-teal-700 transition hover:bg-teal-100"
                          >
                            <FaFileAlt className="shrink-0 text-base" />
                          </a>
                        )}
                        <button onClick={() => updateStatus(app.id, 'Shortlisted')} className="min-w-0 flex-1 inline-flex min-h-9 items-center justify-center gap-1.5 rounded-lg bg-emerald-600 px-2 py-2 text-xs font-bold text-white transition hover:bg-emerald-700">
                          <FaCheck className="shrink-0" /> Shortlist
                        </button>
                        <button onClick={() => updateStatus(app.id, 'Rejected')} className="min-w-0 flex-1 inline-flex min-h-9 items-center justify-center gap-1.5 rounded-lg border border-rose-200 bg-white px-2 py-2 text-xs font-bold text-rose-600 transition hover:bg-rose-50">
                          <FaTimes className="shrink-0" /> Reject
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Desktop Applications - original design preserved */}
            <div className="hidden lg:block">
{activeTab === 'applications' && (

<div className="w-full">

  {/* Heading */}
  <div className="mb-8">
    <h1 className="text-2xl    font-bold text-slate-900">
      Applicants
    </h1>
    <p className="text-slate-500 mt-2">
      Review candidates and manage their application status.
    </p>
  </div>

  {applications.length === 0 ? (

    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-12 text-center">
      <div className="w-16 h-16 rounded-2xl bg-teal-50 flex items-center justify-center mx-auto mb-4">
        <FaUsers className="text-3xl text-teal-600" />
      </div>

      <h2 className="text-base   font-bold text-slate-800">
        No applications yet
      </h2>
      <p className="text-slate-500 mt-2">
        Candidate applications will appear here.
      </p>
    </div>

  ) : (

    <div className="space-y-4 sm:space-y-5">

      {applications.map((app) => (

        <div
          key={app.id}
          className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-teal-200 transition-all duration-200 p-3   "
        >

          {/* Candidate Information */}
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">

            <div className="flex items-start gap-4 min-w-0">

              {/* Initial Avatar */}
              <div className="w-12 h-12 shrink-0 rounded-xl bg-teal-50 text-teal-700 flex items-center justify-center text-xl font-bold">
                {app.name?.trim()?.charAt(0)?.toUpperCase() || "C"}
              </div>

              <div className="min-w-0">

                <h2 className="text-base   uppercase  font-bold text-slate-900 break-words">
                  {app.name}
                </h2>

                <p className="text-base   text-teal-700 capitalize font-medium mt-1">
                  {app.role}
                </p>
                <div className="mt-4 space-y-3 text-base text-slate-600">

                  <p className="flex items-center gap-3 break-all">
                    <FaPhone className="text-teal-600 shrink-0" />
                    <p className="text-base   font-bold">
                      {app.is_unlocked
                        ? (app.phone || 'Not Available')
                        : 'XXXXXXXXXX'}
                    </p>

                  </p>

                  <p className="flex items-center gap-3 break-all">
                    <FaEnvelope className="text-teal-600 shrink-0" />
                    <p className="text-base   font-bold">
                        {app.is_unlocked
                          ? (app.email || 'Not Available')
                          : 'XXXXXXXXXX'}
                      </p>
                  </p>

                <div className={`flex items-center gap-3 text-xl font-medium ${
                  app.has_resume ? "text-emerald-700" : "text-rose-600"
                }`}>
                  <FaFileAlt className="shrink-0" />
                  <p>
                    {app.has_resume
                      ? "Resume Available"
                      : "Resume Not Available"}
                  </p>
                </div>


                </div>

              </div>
            </div>

            {/* Status */}
            <div className="sm:pt-1 sm:shrink-0">
              <span
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm   font-semibold ${
                  app.status === "Shortlisted"
                    ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                    : app.status === "Rejected"
                    ? "bg-red-50 text-red-700 border border-red-200"
                    : "bg-amber-50 text-amber-700 border border-amber-200"
                }`}
              >
                <span
                  className={`w-2 h-2 rounded-full ${
                    app.status === "Shortlisted"
                      ? "bg-emerald-500"
                      : app.status === "Rejected"
                      ? "bg-red-500"
                      : "bg-amber-500"
                  }`}
                />
                {app.status || "Pending"}
              </span>
            </div>

          </div>

          {/* Divider */}
          <div className="border-t border-slate-100 my-6" />

          {/* Actions */}
          <div className="flex flex-wrap items-center gap-3">
            
    {!app.is_unlocked && (
  <button
    onClick={() => unlockCandidate(app.candidate_id)}
    className="bg-emerald-600 text-white px-3 sm:px-5 py-1.5 sm:py-2 rounded-xl"
  >
    Unlock Profile
  </button>
)}
            {app.resume_url && (
              <a
                href={`${API_URL.replace('/api', '')}/${app.resume_url.replace(
                  "backend/",
                  ""
                )}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-teal-50 text-teal-700 border border-teal-200 px-3 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold hover:bg-teal-100 transition-colors"
              >
                <FaFileAlt />
                View Resume
              </a>
            )}

            <button
              onClick={() =>
                updateStatus(
                  app.id,
                  "Shortlisted"
                )
              }
              className="inline-flex items-center justify-center gap-2 bg-emerald-600 text-white px-3 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold hover:bg-emerald-700 transition-colors"
            >
              <FaCheck />
              Shortlist
            </button>

            <button
              onClick={() =>
                updateStatus(
                  app.id,
                  "Rejected"
                )
              }
              className="inline-flex items-center justify-center gap-2 bg-white text-red-600 border border-red-200 px-3 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold hover:bg-red-50 transition-colors"
            >
              <FaTimes />
              Reject
            </button>

          </div>

        </div>

      ))}

    </div>

  )}

</div>


)}

            </div>
          </>
        )}

{activeTab === 'savedCandidates' && (
  <>
    {/* MOBILE SAVED CANDIDATES */}
    <div className="lg:hidden space-y-5">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-500 px-5 py-6 text-white shadow-lg">
        <div className="relative z-10">
          <div className="flex items-start justify-between gap-3">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-white/25 bg-white/15">
              <FaBookmark className="text-xl" />
            </div>
            <div className="shrink-0 rounded-xl border border-white/20 bg-white/15 px-3 py-2 text-center">
              <p className="text-xl font-extrabold leading-none">{savedCandidates.length}</p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-wide">Saved</p>
            </div>
          </div>
          <div className="mt-3 min-w-0">
            <h1 className="text-xl font-extrabold leading-tight">Saved Candidates</h1>
            <p className="mt-1 text-sm leading-5 text-teal-50">Your saved healthcare professionals</p>
          </div>
        </div>
      </div>

      {savedCandidates.length === 0 ? (
        <div className="rounded-2xl border border-slate-200 bg-white px-5 py-9 text-center shadow-sm">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50">
            <FaBookmark className="text-2xl text-teal-600" />
          </div>
          <h2 className="mt-4 text-base font-bold text-slate-900">No Saved Candidates</h2>
          <p className="mx-auto mt-2 max-w-xs text-sm leading-6 text-slate-500">Candidates you save from Candidate Search will appear here.</p>
          <button type="button" onClick={() => setActiveTab('candidateSearch')} className="mt-5 inline-flex items-center justify-center gap-2 rounded-xl bg-teal-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-teal-700">
            <FaSearch className="text-sm" /> Find Candidates
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {savedCandidates.map((candidate) => (
            <div key={candidate.saved_candidate_id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
              <div className="h-1.5 bg-gradient-to-r from-teal-500 to-emerald-400" />
              <div className="p-4">
                <div className="flex min-w-0 items-center gap-3">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-teal-100 bg-teal-50">
                    <FaUser className="text-xl text-teal-700" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h2 className="break-words text-base font-extrabold uppercase leading-snug text-slate-900">{candidate.name || 'Candidate'}</h2>
                    <p className="mt-1 text-xs text-slate-500">Saved Candidate</p>
                  </div>
                </div>

                <div className="mt-4 space-y-3 rounded-xl bg-slate-50 p-3">
                  <div className="flex min-w-0 items-center gap-3">
                    <FaPhoneAlt className="w-4 shrink-0 text-sm text-teal-600" />
                    <span className="min-w-0 break-words text-sm font-medium text-slate-700">{candidate.phone || 'Not available'}</span>
                  </div>
                  <div className="flex min-w-0 items-center gap-3">
                    <FaGraduationCap className="w-4 shrink-0 text-base text-teal-600" />
                    <span className="min-w-0 break-words text-sm font-medium capitalize text-slate-700">{candidate.qualification || 'Not specified'}</span>
                  </div>
                  <div className="flex min-w-0 items-center gap-3">
                    <FaBriefcase className="w-4 shrink-0 text-sm text-teal-600" />
                    <span className="min-w-0 break-words text-sm font-medium text-slate-700">{candidate.experience_years ?? 'Not specified'} Years</span>
                  </div>
                  <div className="flex min-w-0 items-center gap-3">
                    <FaMapMarkerAlt className="w-4 shrink-0 text-sm text-teal-600" />
                    <span className="min-w-0 break-words text-sm font-medium capitalize text-slate-700">{candidate.location || 'Not specified'}</span>
                  </div>
                </div>

                <div className="mt-4 grid grid-cols-3 gap-2 border-t border-slate-100 pt-4">
                  <a href={`/candidate/${candidate.id}`} title="View profile" aria-label={`View profile of ${candidate.name || 'candidate'}`} className="flex h-9 min-w-0 items-center justify-center rounded-lg bg-teal-600 text-white transition hover:bg-teal-700">
                    <FaUser className="text-sm" />
                  </a>
                  {candidate.resume_url ? (
                    <a href={`${API_URL.replace('/api', '')}/${candidate.resume_url}`} target="_blank" rel="noreferrer" title="Open resume" aria-label={`Open resume for ${candidate.name || 'candidate'}`} className="flex h-9 min-w-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-teal-700 transition hover:border-teal-300 hover:bg-teal-50">
                      <FaFileAlt className="text-sm" />
                    </a>
                  ) : (
                    <div title="Resume not available" aria-label="Resume not available" className="flex h-9 min-w-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50 text-slate-300">
                      <FaFileAlt className="text-sm" />
                    </div>
                  )}
                  <button type="button" onClick={() => removeSavedCandidate(candidate.saved_candidate_id)} title="Remove saved candidate" aria-label={`Remove ${candidate.name || 'candidate'}`} className="flex h-9 min-w-0 items-center justify-center rounded-lg border border-rose-200 bg-rose-50 text-rose-600 transition hover:bg-rose-100">
                    <FaTrashAlt className="text-sm" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* DESKTOP SAVED CANDIDATES - ORIGINAL DESIGN */}
    <div className="hidden lg:block">
        <div className="space-y-6">

    {/* Page Header */}
    <div>
      <h1 className="text-2xl    font-bold text-slate-900">
        Saved Candidates
      </h1>
      <p className="text-base   text-slate-500 mt-2">
        Manage your shortlisted healthcare professionals.
      </p>
    </div>

    {/* Empty State */}
    {savedCandidates.length === 0 ? (
      <div className="bg-white rounded-2xl border border-slate-200
                      shadow-sm p-12 text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-teal-50
                        flex items-center justify-center">
          <FaBookmark className="text-4xl text-teal-600" />
        </div>

        <h2 className="text-lg   font-bold text-slate-900 mt-5">
          No Saved Candidates
        </h2>

        <p className="text-base   text-slate-500 mt-2">
          Candidates you save will appear here.
        </p>
      </div>
    ) : (

      /* Candidate Cards */
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-6">

        {savedCandidates.map((candidate) => (
          <div
            key={candidate.saved_candidate_id}
            className="group bg-white rounded-2xl border border-slate-200
                       shadow-sm hover:shadow-lg hover:border-teal-200
                       transition-all duration-300 overflow-hidden
                       flex flex-col"
          >

            {/* Top Accent */}
            <div className="h-1.5 bg-gradient-to-r from-teal-500 to-emerald-500" />

            <div className="p-6 flex flex-col flex-1">

              {/* Candidate Header */}
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 shrink-0 rounded-2xl
                                bg-teal-50 border border-teal-100
                                flex items-center justify-center">
                  <FaUser className="text-3xl text-teal-700" />
                </div>

                <div className="min-w-0">
                  <h2 className="text-lg    font-bold
                                 text-slate-900 uppercase break-words
                                 group-hover:text-teal-700 transition-colors">
                    {candidate.name || "Candidate"}
                  </h2>

                  <p className="text-sm   text-slate-500 mt-1">
                    Saved Candidate
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-slate-100 my-5" />

              {/* Candidate Details */}
              <div className="space-y-4 flex-1">

                {/* Phone */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaPhoneAlt className="text-xl text-teal-600" />
                  </div>

                  <p className="text-base    font-medium
                                text-slate-700 break-words">
                    {candidate.phone || "Not available"}
                  </p>
                </div>

                {/* Qualification */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaGraduationCap className="text-2xl text-teal-600" />
                  </div>

                  <p className="text-base   capitalize  font-medium
                                text-slate-700 break-words">
                    {candidate.qualification || "Not specified"}
                  </p>
                </div>

                {/* Experience */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaBriefcase className="text-xl text-teal-600" />
                  </div>

                  <p className="text-base    font-medium text-slate-700">
                    {candidate.experience_years ?? "Not specified"} Years
                  </p>
                </div>

                {/* Location */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 shrink-0 rounded-xl
                                  bg-teal-50 flex items-center justify-center">
                    <FaMapMarkerAlt className="text-xl text-teal-600" />
                  </div>

                  <p className="text-base   capitalize  font-medium
                                text-slate-700 break-words">
                    {candidate.location || "Not specified"}
                  </p>
                </div>

              </div>

              {/* Bottom Actions */}
              <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_48px] gap-2 sm:gap-3
                              mt-6 pt-5 border-t border-slate-100 w-full min-w-0">

                {/* View Profile */}
                <a
                  href={`/candidate/${candidate.id}`}
                  className="inline-flex min-w-0 items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-2 sm:px-3 py-2 sm:py-3 rounded-xl font-semibold text-sm sm:text-base text-center transition-all duration-200"
                >
                  <FaUser className="shrink-0" />
                  <span className="min-w-0 whitespace-normal break-words leading-tight">View Profile</span>
                </a>

                {/* Resume */}
                {candidate.resume_url ? (
                  <a
                    href={`${API_URL.replace('/api', '')}/${candidate.resume_url}`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex min-w-0 items-center justify-center gap-2 bg-white border border-slate-200 hover:bg-teal-50 hover:border-teal-400 text-slate-700 hover:text-teal-700 px-3 py-2 sm:py-3 rounded-xl font-semibold text-sm sm:text-base transition-all duration-200 whitespace-nowrap"
                  >
                    <FaFileAlt />
                    <span>Resume</span>
                  </a>
                ) : (
                  <div
                    className="inline-flex items-center justify-center gap-2
                               bg-slate-50 border border-slate-200
                               text-slate-400 px-3 py-3 rounded-xl
                               font-medium text-base"
                    title="Resume not available"
                  >
                    <FaFileAlt />
                    <span>No Resume</span>
                  </div>
                )}

                {/* Remove Candidate */}
                <button
                  type="button"
                  onClick={() =>
                    removeSavedCandidate(candidate.saved_candidate_id)
                  }
                  title="Remove saved candidate"
                  aria-label={`Remove ${candidate.name || "candidate"}`}
                  className="w-12 min-w-12 shrink-0 flex items-center justify-center bg-rose-50 border border-rose-200 hover:bg-rose-100 hover:border-rose-300 text-rose-600 rounded-xl transition-all duration-200"
                >
                  <FaTrashAlt className="text-lg shrink-0" />
                </button>

              </div>

            </div>
          </div>
        ))}

      </div>
    )}
  </div>
    </div>
  </>
)}

{activeTab === "recruiterProfile" && (

<div className="min-w-0">

  {/* MOBILE HEADER - consistent with the other dashboard pages */}
  <div className="lg:hidden relative overflow-hidden rounded-[1.6rem] bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-500 text-white p-5 mb-5 shadow-md">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 mb-2">
          <FaUserTie className="text-xl shrink-0" />
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-teal-50">Institution dashboard</p>
        </div>
        <h1 className="text-2xl font-extrabold leading-tight">Recruiter Profile</h1>
        <p className="text-sm text-teal-50 mt-2 leading-5">Manage your professional and company information.</p>
      </div>
      <div className="shrink-0 w-12 h-12 rounded-2xl bg-white/15 border border-white/20 flex items-center justify-center">
        <FaUser className="text-xl" />
      </div>
    </div>
  </div>

  <h1 className="hidden lg:block text-2xl font-bold mb-8">
    Recruiter Profile
  </h1>

  {/* PROFILE SUB TABS */}
  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-1.5 sm:p-2 mb-4 sm:mb-6 grid grid-cols-2 gap-1.5 sm:flex sm:flex-row sm:gap-2">

  <button
    type="button"
    onClick={() => setProfileTab('myProfile')}
    className={`flex-1 min-h-11 sm:min-h-12 py-2 sm:py-3 px-2 sm:px-5 text-sm sm:text-base rounded-xl font-semibold transition flex items-center justify-center gap-1.5 sm:gap-2 ${
      profileTab === 'myProfile'
        ? 'bg-teal-600 text-white'
        : 'text-gray-600 hover:bg-gray-100'
    }`}
  >
    <FaUser className="shrink-0 text-sm sm:text-base" />
    <span>My Profile</span>
  </button>

  <button
    type="button"
    onClick={() => setProfileTab('changePassword')}
    className={`flex-1 min-h-11 sm:min-h-12 py-2 sm:py-3 px-2 sm:px-5 text-sm sm:text-base rounded-xl font-semibold transition flex items-center justify-center gap-1.5 sm:gap-2 ${
      profileTab === 'changePassword'
        ? 'bg-teal-600 text-white'
        : 'text-gray-600 hover:bg-gray-100'
    }`}
  >
    <FaLock className="shrink-0 text-sm sm:text-base" />
    <span>Change Password</span>
  </button>

</div>


  {/* ============================= */}
  {/* MY PROFILE */}
  {/* ============================= */}

{profileTab === 'myProfile' && (
  <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm sm:shadow-lg border border-gray-100 p-2.5 sm:p-5 lg:p-6">

    {/* Profile Header */}
    <div className="bg-gradient-to-br from-teal-50 to-emerald-50 border border-teal-100 rounded-2xl sm:rounded-[2rem] p-4 sm:p-6 md:p-10 mb-4 sm:mb-8">
      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8">

        {/* Company Logo */}
        <div className="flex flex-col items-center shrink-0">
          <div className="relative">
            <img
              src={
                (recruiterProfile.company_logo || user.company_logo)
                  ? `${API_URL.replace('/api', '')}/${recruiterProfile.company_logo || user.company_logo}`
                  : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      recruiterProfile.company_name || user.name || 'Company'
                    )}&size=256&background=f0fdfa&color=0f766e`
              }
              alt="Company Logo"
              className="w-24 h-24 sm:w-36 sm:h-36 rounded-full object-cover border-4 border-white shadow-md"
            />

            <span className="absolute bottom-1 right-1 w-6 h-6 bg-emerald-500 border-2 border-white rounded-full"></span>
          </div>

          <label
            htmlFor="companyLogo"
            className="mt-3 sm:mt-5 inline-flex items-center justify-center px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base rounded-xl border border-teal-200 bg-white text-teal-700 font-semibold cursor-pointer hover:bg-teal-50 transition"
          >
            Upload Photo
          </label>

          <input
            id="companyLogo"
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => setCompanyLogoFile(e.target.files[0])}
          />
        </div>

        {/* Profile Information */}
        <div className="min-w-0 w-full text-center sm:text-left">
          <p className="text-teal-700 font-semibold uppercase tracking-wide text-sm   mb-2 sm:mb-3">
            Recruiter Profile
          </p>

          <h2 className="text-lg sm:text-xl font-bold text-slate-900 break-words">
            {recruiterProfile.recruiter_name || user.name || 'Your Name'}
          </h2>

          <p className="text-sm sm:text-base text-gray-500 mt-2 sm:mt-3">
            Keep your professional information up to date
          </p>

          {recruiterProfile.company_name && (
            <p className="text-teal-700 font-medium mt-2">
              {recruiterProfile.company_name}
            </p>
          )}
        </div>
      </div>
    </div>

    {/* Professional Details */}
    <div className="border border-slate-200 rounded-2xl sm:rounded-[2rem] p-3.5 sm:p-6 md:p-10">

      <div className="mb-5 sm:mb-8">
        <h3 className="text-xl   font-bold text-slate-900">
          Professional Details
        </h3>

        <p className="text-gray-500 mt-2">
          Add your company information and recruiter details.
        </p>
      </div>

      {/* Basic Fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 sm:gap-y-6">

        {/* Recruiter Name */}
        <div>
          <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
            Recruiter Name
          </label>

          <input
            type="text"
            placeholder="Enter recruiter name"
            value={recruiterProfile.recruiter_name}
            onChange={(e) =>
              setRecruiterProfile({
                ...recruiterProfile,
                recruiter_name: e.target.value
              })
            }
            className="w-full bg-slate-50 border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:bg-white focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition"
          />
        </div>

        {/* Company Name */}
        <div>
          <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
            Company Name
          </label>

          <input
            type="text"
            placeholder="Enter company name"
            value={recruiterProfile.company_name}
            onChange={(e) =>
              setRecruiterProfile({
                ...recruiterProfile,
                company_name: e.target.value
              })
            }
            className="w-full bg-white border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition"
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
            Phone Number
          </label>

          <input
            type="text"
            placeholder="Enter phone number"
            value={recruiterProfile.phone}
            onChange={(e) =>
              setRecruiterProfile({
                ...recruiterProfile,
                phone: e.target.value
              })
            }
            className="w-full bg-white border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
            Email Address
          </label>

          <input
            type="email"
            placeholder="Enter email address"
            value={recruiterProfile.email}
            onChange={(e) =>
              setRecruiterProfile({
                ...recruiterProfile,
                email: e.target.value
              })
            }
            className="w-full bg-white border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition"
          />
        </div>

        {/* Website */}
        <div className="md:col-span-2">
          <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
            Company Website
          </label>

          <input
            type="text"
            placeholder="e.g. https://www.example.com"
            value={recruiterProfile.website}
            onChange={(e) =>
              setRecruiterProfile({
                ...recruiterProfile,
                website: e.target.value
              })
            }
            className="w-full bg-white border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition"
          />
        </div>

      </div>

      {/* Address */}
      <div className="mt-7">
        <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
          Company Address
        </label>

        <textarea
          placeholder="Enter your company address"
          rows="3"
          value={recruiterProfile.address}
          onChange={(e) =>
            setRecruiterProfile({
              ...recruiterProfile,
              address: e.target.value
            })
          }
          className="w-full bg-white border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition resize-y"
        />
      </div>

      {/* About Company */}
      <div className="mt-7">
        <label className="block text-base font-semibold text-slate-800 mb-2 sm:mb-3">
          About Company
        </label>

        <textarea
          placeholder="Tell candidates about your company, culture and workplace..."
          rows="5"
          value={recruiterProfile.about}
          onChange={(e) =>
            setRecruiterProfile({
              ...recruiterProfile,
              about: e.target.value
            })
          }
          className="w-full bg-white border border-slate-200 rounded-xl sm:rounded-2xl px-3.5 sm:px-5 py-3.5 sm:py-5 text-sm sm:text-base text-slate-800 placeholder-gray-400 outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100 transition resize-y"
        />
      </div>

      {/* Save Profile */}
      <div className="mt-5 sm:mt-8 flex justify-stretch sm:justify-end">
        <button
          type="button"
          onClick={saveRecruiterProfile}
          className="w-full sm:w-auto bg-teal-600 text-white font-semibold px-5 sm:px-8 py-3 sm:py-4 text-sm sm:text-base rounded-xl hover:bg-teal-700 active:scale-[0.98] transition shadow-md hover:shadow-lg"
        >
          Save Profile
        </button>
      </div>

    </div>
  </div>
)}


  {/* ============================= */}
  {/* CHANGE PASSWORD */}
  {/* ============================= */}

  {profileTab === 'changePassword' && (

    <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm sm:shadow-lg border border-gray-100 p-3.5 sm:p-4 max-w-2xl">

      <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-2">
        Change Password
      </h2>

      <p className="text-sm sm:text-base text-gray-500 mb-5 sm:mb-8">
        Update your recruiter account password.
      </p>


      {/* MESSAGE */}

      {changePasswordMessage && (
        <div
          className={`mb-6 p-4 rounded-xl font-medium ${
            changePasswordMessageType === 'success'
              ? 'bg-green-100 text-green-700'
              : 'bg-red-100 text-red-700'
          }`}
        >
          {changePasswordMessage}
        </div>
      )}


      {/* CURRENT PASSWORD */}

      <div className="mb-5">

        <label className="block text-base font-semibold text-gray-700 mb-2">
          Current Password
        </label>

        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Enter current password"
          className="w-full min-w-0 border border-gray-300 px-3.5 sm:px-4 py-3.5 sm:py-4 text-sm sm:text-base rounded-xl outline-none focus:ring-2 focus:ring-teal-500"
        />

      </div>


      {/* NEW PASSWORD */}

      <div className="mb-5">

        <label className="block text-base font-semibold text-gray-700 mb-2">
          New Password
        </label>

        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Enter new password"
          className="w-full min-w-0 border border-gray-300 px-3.5 sm:px-4 py-3.5 sm:py-4 text-sm sm:text-base rounded-xl outline-none focus:ring-2 focus:ring-teal-500"
        />

      </div>


      {/* CONFIRM PASSWORD */}

      <div className="mb-6">

        <label className="block text-base font-semibold text-gray-700 mb-2">
          Confirm New Password
        </label>

        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          className="w-full min-w-0 border border-gray-300 px-3.5 sm:px-4 py-3.5 sm:py-4 text-sm sm:text-base rounded-xl outline-none focus:ring-2 focus:ring-teal-500"
        />

      </div>


      {/* CHANGE PASSWORD BUTTON */}

      <button
        type="button"
        onClick={handleChangePassword}
        disabled={changePasswordLoading}
        className={`w-full sm:w-auto bg-teal-600 text-white px-4 sm:px-8 py-3 sm:py-4 text-sm sm:text-base rounded-xl sm:rounded-2xl font-bold transition ${
          changePasswordLoading
            ? "opacity-60 cursor-not-allowed"
            : "hover:bg-teal-700"
        }`}
      >
        {changePasswordLoading
          ? "Changing Password..."
          : "Change Password"}
      </button>

    </div>

  )}

</div>

)}

      </div>

    </div>

  );
}

export default InstitutionDashboard;